export const generatedCustomerReportPacketLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-customer-report-packet-ledger",
  "operatingRule": "Customer report packets assemble package-specific executive answers, evidence appendices, proof gates, diligence work orders, and export contracts. They are internal/paid-beta scoping artifacts until source-use, runtime, economics, materials, resource, workspace, UI, and reviewer gates pass.",
  "reportPacketCount": 3,
  "blockedReportPacketCount": 3,
  "customerReadyReportPacketCount": 0,
  "reportExportCount": 3,
  "blockedReportExportCount": 3,
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "evidenceHashes": {
    "feasibilityReport": "fnv1a32-5b0df6f9",
    "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
    "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
    "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
    "scenarioDecisionDeltaLedger": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
    "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
  },
  "reportPackets": [
    {
      "id": "customer-report-packet-package-investor-feasibility-brief-v1",
      "packageId": "package-investor-feasibility-brief-v1",
      "title": "Investor Feasibility Brief Package Customer Report Packet",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "reportState": "beta-report-blocked",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "deliverableType": "paid-beta-feasibility-intelligence",
      "customerQuestion": "Given current public evidence, which off-world industrial scenario is most plausible and what would need to change the ranking?",
      "buyerFit": [
        "deep-tech investors",
        "strategic foresight teams",
        "aerospace concept teams"
      ],
      "executiveAnswer": {
        "selectedScenarioId": "hybrid",
        "selectedScenarioName": "Hybrid Moon -> Asteroid -> Mercury",
        "topDecisionScenarioId": "moon-first",
        "confidenceBand": "research-backlog-confidence",
        "currentAnswer": "Use the current ranking as decision support only; it is not a mission design, verified resource claim, or cleared customer report until the listed gates close.",
        "buyerFacingValue": "Converts public science, engineering, economics, and source-rights evidence into reproducible scenario comparisons with explicit uncertainty and blockers.",
        "sellableBetaLane": "paid-beta-internal-diligence-with-citation-review",
        "commercializationAllowed": false
      },
      "readerSections": [
        {
          "id": "executive-answer",
          "title": "Executive answer",
          "status": "decision-support-only",
          "contentBoundary": "May describe current model output and uncertainty, but cannot be presented as validated mission design or cleared commercial advice."
        },
        {
          "id": "scenario-comparison",
          "title": "Scenario comparison",
          "status": "hash-backed-beta",
          "contentBoundary": "Must show ranked scenarios, uncertainty, proof-to-change-answer, and why Mercury-first is not hardcoded."
        },
        {
          "id": "evidence-and-blockers",
          "title": "Evidence and blockers",
          "status": "required",
          "contentBoundary": "Must include source-use, runtime sidecar, economics, resource, materials/process, workspace, and reviewer blockers."
        },
        {
          "id": "diligence-work-orders",
          "title": "Diligence work orders",
          "status": "paid-beta-scope",
          "contentBoundary": "May be sold as scoped diligence work; cannot be sold as proof until after-run delta acceptance records pass."
        }
      ],
      "scenarioBriefs": [
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "customerUseState": "research-backlog-only",
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "proofToChangeAnswer": {
            "crossoverId": "crossover-hybrid-over-moon-first",
            "challengerScenarioId": "hybrid",
            "currentLeaderScenarioId": "moon-first",
            "requiredUtilityDelta": 1.43,
            "crossoverState": "mathematically-reachable-not-validated",
            "topLeverPaths": [
              {
                "kind": "uncertainty-reduction",
                "criterion": "uncertaintyPenalty",
                "currentValue": 12,
                "direction": "decrease",
                "utilityPerPoint": 0.42,
                "requiredRawDelta": 3.4,
                "feasibleByRawRange": true,
                "headroom": 12
              },
              {
                "kind": "risk-reduction",
                "criterion": "transport",
                "currentValue": 46,
                "direction": "decrease",
                "utilityPerPoint": 0.1378,
                "requiredRawDelta": 10.38,
                "feasibleByRawRange": true,
                "headroom": 46
              },
              {
                "kind": "risk-reduction",
                "criterion": "feedstock",
                "currentValue": 55,
                "direction": "decrease",
                "utilityPerPoint": 0.1378,
                "requiredRawDelta": 10.38,
                "feasibleByRawRange": true,
                "headroom": 55
              }
            ],
            "crossoverHash": "sha256-3f18573eaa49677e7506a5604e505ffe279334d0b5f95dcfa82fd24a47342916"
          },
          "topBlockers": [
            "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
            "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
            "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
            "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound."
          ],
          "nextProofActions": [
            "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
            "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "Approve source-use review packets before customer-facing redistribution or derived-value claims."
          ],
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
        },
        {
          "scenarioId": "moon-first",
          "dossierId": "customer-dossier-moon-first",
          "name": "Moon-first Bootstrap",
          "customerUseState": "paid-beta-internal-diligence",
          "decisionLane": "lane-2-conditional-diligence",
          "decisionReadinessScore": 62.91,
          "uncertaintyBudgetPoints": 29.81,
          "proofToChangeAnswer": {
            "crossoverId": "crossover-hybrid-over-moon-first",
            "challengerScenarioId": "hybrid",
            "currentLeaderScenarioId": "moon-first",
            "requiredUtilityDelta": 1.43,
            "crossoverState": "mathematically-reachable-not-validated",
            "topLeverPaths": [
              {
                "kind": "uncertainty-reduction",
                "criterion": "uncertaintyPenalty",
                "currentValue": 12,
                "direction": "decrease",
                "utilityPerPoint": 0.42,
                "requiredRawDelta": 3.4,
                "feasibleByRawRange": true,
                "headroom": 12
              },
              {
                "kind": "risk-reduction",
                "criterion": "transport",
                "currentValue": 46,
                "direction": "decrease",
                "utilityPerPoint": 0.1378,
                "requiredRawDelta": 10.38,
                "feasibleByRawRange": true,
                "headroom": 46
              },
              {
                "kind": "risk-reduction",
                "criterion": "feedstock",
                "currentValue": 55,
                "direction": "decrease",
                "utilityPerPoint": 0.1378,
                "requiredRawDelta": 10.38,
                "feasibleByRawRange": true,
                "headroom": 55
              }
            ],
            "crossoverHash": "sha256-3f18573eaa49677e7506a5604e505ffe279334d0b5f95dcfa82fd24a47342916"
          },
          "topBlockers": [
            "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
            "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
            "orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
            "gmat-transfer-v1 runtime evidence missing for moon-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
          ],
          "nextProofActions": [
            "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
            "Attach dated launch/capex/opex/market sources and calibrated economics artifacts."
          ],
          "dossierHash": "sha256-9875bb78ef63e46d736345da0f793778851eafb82f37ef91ca9edde3f3db3573"
        }
      ],
      "diligenceWorkOrders": [
        {
          "id": "diligence-work-order-01-gap-runtime-orekit-propagation-v1",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "workOrderHash": "sha256-baa82fd4ea74aad62b55dfc56fd78e1513cac8ba3a0e6cbc136c02b3d128e4d1"
        },
        {
          "id": "diligence-work-order-02-gap-runtime-gmat-transfer-v1",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "workOrderHash": "sha256-571ba2ce848959e9016799486d0505720f857685f02a601c2cc09e7f58a3e476"
        },
        {
          "id": "diligence-work-order-03-gap-runtime-tudat-transfer-v1",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "workOrderHash": "sha256-74ae877ca9b3c8c030f093f9b35cfd3239f6069c924c1f0da02bf9b6c1d98710"
        },
        {
          "id": "diligence-work-order-04-gap-materials-process-oxygen-isru",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
          "workOrderHash": "sha256-bdf99d78b39494df13a8409aa9336affd690e24fd93ec58fdc5b56e258143622"
        },
        {
          "id": "diligence-work-order-05-gap-readiness-science-math-credibility",
          "lane": "release-proof",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Required to raise the beta from testable to release-grade.",
          "nextAction": "Source Registry 2.0, assumption registry, scenario notebooks, generated model-artifact bundles, seeded scenario uncertainty analysis, generated economics frontier artifacts, business-case planning heuristics, one SPICE GF runtime artifact, and one OpenMDAO/Dymos beta optimization artifact are now local and tested, but Orekit/GMAT/Tudat runtime artifacts are not yet generated.",
          "workOrderHash": "sha256-6e0809c818212af1f7017609be842f01e31c381d04b54fc7f66db8f75606e2d6"
        },
        {
          "id": "diligence-work-order-06-gap-candidate-source-2026-em",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
          "workOrderHash": "sha256-ca289d3590ea16900ade0899719bc6f367b45d272c91c2e61f4110ea941a5e16"
        },
        {
          "id": "diligence-work-order-07-gap-candidate-source-2026-jm2",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
          "workOrderHash": "sha256-708045573dcd7b1b11a8d0644a1306575d7ae399481f6842235f66802c679332"
        },
        {
          "id": "diligence-work-order-08-gap-candidate-source-2026-dn5",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
          "workOrderHash": "sha256-7aba6c179ff641753e4dcf699a4c2e196f07d7a2ebadbb931690035802d2f143"
        },
        {
          "id": "diligence-work-order-09-gap-materials-process-spf-db",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and thermal cycle energy balance for Superplastic Forming / Diffusion Bonding.",
          "workOrderHash": "sha256-0f76d2cba16f3e50d606a4ca6ba58e7b0b55ff94806314a9f1fc37a2016034b4"
        },
        {
          "id": "diligence-work-order-10-gap-materials-process-vacuum-sheet",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing.",
          "workOrderHash": "sha256-ef9e747934d358294e2459299e33ef07454fd7880972a251177e083cda4c7169"
        },
        {
          "id": "diligence-work-order-11-gap-resource-taxonomy-spectra-record",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
          "workOrderHash": "sha256-ce13be2de8e222b90b3f72ab64e82567f72bc328ddf50d0cdf34b08ecf7cd089"
        },
        {
          "id": "diligence-work-order-12-gap-economics-launch-list-price-source",
          "lane": "economics-sensitivity",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Do dated, normalized cost and market inputs change the scenario ranking or capital gap?",
          "nextAction": "Normalize launch-cost records into model-ready numeric inputs with calibration artifacts.",
          "workOrderHash": "sha256-98529615ecd1f236b1f6ea583e4019269b6871fe39b3b94d8d0dc2b797ce60e6"
        }
      ],
      "decisionDeltaAcceptance": [
        {
          "id": "decision-delta-diligence-work-order-01-gap-runtime-orekit-propagation-v1",
          "workOrderId": "diligence-work-order-01-gap-runtime-orekit-propagation-v1",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-696d7bc5b812c609e983bf3c079ea9563eab372629e6c8847f831b0238d1f98a"
        },
        {
          "id": "decision-delta-diligence-work-order-02-gap-runtime-gmat-transfer-v1",
          "workOrderId": "diligence-work-order-02-gap-runtime-gmat-transfer-v1",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-1d9e48de12c1383de449b7b80a4a1172bb99fa0ed70cb8a8a7f690c2a5af0ee1"
        },
        {
          "id": "decision-delta-diligence-work-order-03-gap-runtime-tudat-transfer-v1",
          "workOrderId": "diligence-work-order-03-gap-runtime-tudat-transfer-v1",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-dd7181fa4835fbf55f8cc5153d6058a2e2ab8244eab1ad37cb46cd9c5221f562"
        },
        {
          "id": "decision-delta-diligence-work-order-04-gap-materials-process-oxygen-isru",
          "workOrderId": "diligence-work-order-04-gap-materials-process-oxygen-isru",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-df7112d8c2bc06bcc2841ce59520b9ee885d5eeac25df494a604b49a79e25b83"
        },
        {
          "id": "decision-delta-diligence-work-order-05-gap-readiness-science-math-credibility",
          "workOrderId": "diligence-work-order-05-gap-readiness-science-math-credibility",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-60ac72f959528d9472829942ff72d11f66c1f5ef35f01e760a401819e06eafa9"
        },
        {
          "id": "decision-delta-diligence-work-order-06-gap-candidate-source-2026-em",
          "workOrderId": "diligence-work-order-06-gap-candidate-source-2026-em",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-e80560acfdc667dad2bc92f845f13cd8b86102818332de3fb04474fcbcda5b5a"
        },
        {
          "id": "decision-delta-diligence-work-order-07-gap-candidate-source-2026-jm2",
          "workOrderId": "diligence-work-order-07-gap-candidate-source-2026-jm2",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-773d432f747db4658c55e62bf6391a5a0810a3656b643105ca7748704fe78898"
        },
        {
          "id": "decision-delta-diligence-work-order-08-gap-candidate-source-2026-dn5",
          "workOrderId": "diligence-work-order-08-gap-candidate-source-2026-dn5",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-21f28e19a52de7ba3e8f2e9a5044ace620f6e821196ba50698501bdedd753f40"
        },
        {
          "id": "decision-delta-diligence-work-order-09-gap-materials-process-spf-db",
          "workOrderId": "diligence-work-order-09-gap-materials-process-spf-db",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-95129d4fc91c08b0c00ca68a2ff935fb273fae66f1edc1de744fff2ca6f59f21"
        },
        {
          "id": "decision-delta-diligence-work-order-10-gap-materials-process-vacuum-sheet",
          "workOrderId": "diligence-work-order-10-gap-materials-process-vacuum-sheet",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-2dd2f4bde9c960b939f68769edcb13c553ce19b66b07e1cd0d7d4926812bd121"
        },
        {
          "id": "decision-delta-diligence-work-order-11-gap-resource-taxonomy-spectra-record",
          "workOrderId": "diligence-work-order-11-gap-resource-taxonomy-spectra-record",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-a7d57999cd5183edec36a6a8900ac7bd7618bbe6be4ee0c9de0241042489605e"
        },
        {
          "id": "decision-delta-diligence-work-order-12-gap-economics-launch-list-price-source",
          "workOrderId": "diligence-work-order-12-gap-economics-launch-list-price-source",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-c3233721471f01f0338f5f8ec60131bf349a311c66d08f2518ab0eecf660efc4"
        }
      ],
      "proofGates": [
        {
          "id": "source-use-rights",
          "label": "Source use rights",
          "status": "blocked",
          "evidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "requiredProof": "Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source."
        },
        {
          "id": "runtime-sidecars",
          "label": "Runtime sidecars",
          "status": "blocked",
          "evidenceHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
          "requiredProof": "Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight."
        },
        {
          "id": "model-validation",
          "label": "Model validation",
          "status": "blocked",
          "evidenceHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
          "requiredProof": "Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval."
        },
        {
          "id": "resource-candidates",
          "label": "Resource candidates",
          "status": "blocked",
          "evidenceHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
          "requiredProof": "Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim."
        },
        {
          "id": "economics",
          "label": "Economics evidence",
          "status": "blocked",
          "evidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "requiredProof": "Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads."
        },
        {
          "id": "materials-process",
          "label": "Materials/process evidence",
          "status": "blocked",
          "evidenceHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
          "requiredProof": "Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts."
        },
        {
          "id": "workspace-review",
          "label": "Workspace review",
          "status": "blocked",
          "evidenceHash": "sha256-39ce4c082cf5d7b374489dc8b8b7a54f6fb0192a04b3f993c9bc499629d3a035",
          "requiredProof": "Workspace gates, selected runs, package scope, and reviewer approvals are closed."
        }
      ],
      "blockedProofGates": [
        {
          "id": "source-use-rights",
          "label": "Source use rights",
          "status": "blocked",
          "requiredProof": "Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source.",
          "evidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
        },
        {
          "id": "runtime-sidecars",
          "label": "Runtime sidecars",
          "status": "blocked",
          "requiredProof": "Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight.",
          "evidenceHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
        },
        {
          "id": "model-validation",
          "label": "Model validation",
          "status": "blocked",
          "requiredProof": "Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval.",
          "evidenceHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
        },
        {
          "id": "resource-candidates",
          "label": "Resource candidates",
          "status": "blocked",
          "requiredProof": "Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim.",
          "evidenceHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608"
        },
        {
          "id": "economics",
          "label": "Economics evidence",
          "status": "blocked",
          "requiredProof": "Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads.",
          "evidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297"
        },
        {
          "id": "materials-process",
          "label": "Materials/process evidence",
          "status": "blocked",
          "requiredProof": "Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts.",
          "evidenceHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80"
        },
        {
          "id": "workspace-review",
          "label": "Workspace review",
          "status": "blocked",
          "requiredProof": "Workspace gates, selected runs, package scope, and reviewer approvals are closed.",
          "evidenceHash": "sha256-39ce4c082cf5d7b374489dc8b8b7a54f6fb0192a04b3f993c9bc499629d3a035"
        }
      ],
      "blockedClaims": [
        "No operational mission design, launch commitment, or flight-dynamics certification.",
        "No asteroid or planetary resource-composition claim without candidate-specific taxonomy, spectra, mission, or sample evidence.",
        "No commercial economics, throughput, process-quality, or manufacturability claim while economics/materials/process ledgers are blocked.",
        "No customer-facing trajectory/event-window claim until the full required runtime set and independent validation gates pass.",
        "No raw source redistribution or customer commercial use until source-use rights review passes."
      ],
      "allowedClaims": [
        "Source-backed beta context claims may be cited only with evidence hashes attached.",
        "Scenario rankings may be used as decision-support heuristics with uncertainty and blocker context visible.",
        "Evidence-gap, crossover, and diligence priorities may be used to scope paid research work."
      ],
      "evidenceAppendix": {
        "packageHash": "sha256-8709add4b60e61a1e7e3f71c9339a266bddac45e4528d51bfcf643e9fcfa1ad3",
        "customerReadinessContractHash": "sha256-f56b586ab243bb595075fe4fabd8d9a828a3dbfd2a9569ad6e7320b61389b6f3",
        "includedArtifactCount": 47,
        "artifactRefs": [
          {
            "id": "artifact-scenario-diligence-work-order-ledger",
            "label": "Scenario diligence work-order ledger",
            "path": "public/scenario-diligence-work-order-ledger.json",
            "hash": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
            "role": "Customer/package-linked diligence work orders, acceptance gates, affected scenarios, replay commands, and decision-delta requirements."
          },
          {
            "id": "artifact-scenario-decision-delta-ledger",
            "label": "Scenario decision delta ledger",
            "path": "public/scenario-decision-delta-ledger.json",
            "hash": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
            "role": "Fail-closed before/after acceptance records proving no diligence work order can change a customer answer without a hashed after-run artifact."
          },
          {
            "id": "artifact-customer-decision-dossier-ledger",
            "label": "Customer decision dossier ledger",
            "path": "public/customer-decision-dossier-ledger.json",
            "hash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
            "role": "Scenario-by-scenario customer-use state, buyer boundary, evidence summary, blockers, proof-to-change-answer, and next proof actions."
          },
          {
            "id": "artifact-model-validation-protocols",
            "label": "Model validation protocol ledger",
            "path": "public/model-validation-protocols.json",
            "hash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
            "role": "Domain-by-domain validation protocols, acceptance criteria, source/runtime gates, blocker states, and commercial-use boundaries."
          },
          {
            "id": "artifact-asteroid-candidate-evidence-ledger",
            "label": "Asteroid candidate evidence ledger",
            "path": "public/asteroid-candidate-evidence-ledger.json",
            "hash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
            "role": "Candidate-level SBDB/CAD/MPC/taxonomy/spectra evidence requirements, blockers, and resource-promotion gates."
          },
          {
            "id": "artifact-candidate-source-promotion-ledger",
            "label": "Candidate source promotion ledger",
            "path": "public/candidate-source-promotion-ledger.json",
            "hash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
            "role": "Candidate work-order source custody, resource-promotion, customer-use gates, report intake state, and explicit work-order gaps."
          },
          {
            "id": "artifact-candidate-source-closure-packets",
            "label": "Candidate source closure packets",
            "path": "public/candidate-source-closure-packets.json",
            "hash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
            "role": "Executable candidate-by-candidate closure packets with missing MPC, review, composition, and customer-use acceptance gates."
          },
          {
            "id": "artifact-capability-maturity-ledger",
            "label": "Capability maturity ledger",
            "path": "public/capability-maturity-ledger.json",
            "hash": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
            "role": "Business capability maturity, source coverage, model coverage, sidecar blockers, and commercialization gates."
          },
          {
            "id": "artifact-claim-evidence-ledger",
            "label": "Claim evidence ledger",
            "path": "public/claim-evidence-ledger.json",
            "hash": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
            "role": "Claim-level source coverage, confidence, promotion gates, allowed use, and blockers."
          },
          {
            "id": "artifact-feasibility-report",
            "label": "Canonical feasibility report",
            "path": "public/feasibility-report.json",
            "hash": "fnv1a32-5b0df6f9",
            "role": "Executive scenario comparison and governance summary."
          },
          {
            "id": "artifact-model-run-ledger",
            "label": "Versioned model-run ledger",
            "path": "public/model-run-ledger.json",
            "hash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
            "role": "Reproducible run inputs, uncertainty settings, rankings, and run hashes."
          },
          {
            "id": "artifact-model-run-comparison-ledger",
            "label": "Model-run comparison ledger",
            "path": "public/model-run-comparison-ledger.json",
            "hash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
            "role": "Run-to-run selected-scenario, rank-one, utility, uncertainty, business-readiness, and replay-boundary deltas."
          },
          {
            "id": "artifact-assumption-impact-ledger",
            "label": "Assumption impact ledger",
            "path": "public/assumption-impact-ledger.json",
            "hash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
            "role": "Assumption-to-scenario sensitivity, source coverage, stress behavior, and promotion gates."
          },
          {
            "id": "artifact-scenario-comparison-board",
            "label": "Scenario comparison board",
            "path": "public/scenario-comparison-board.json",
            "hash": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
            "role": "Business-grade scenario comparison board with decision score, uncertainty budget, economics, traceability, blockers, and CSV/Markdown export hashes."
          },
          {
            "id": "artifact-scenario-notebook-pack",
            "label": "Scenario notebook pack",
            "path": "public/scenario-notebook-pack.json",
            "hash": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
            "role": "Scenario-by-scenario reviewer notebooks with source coverage, open questions, blockers, work orders, and Markdown export hashes."
          },
          {
            "id": "artifact-runtime-validation-campaign-ledger",
            "label": "Runtime validation campaign ledger",
            "path": "public/runtime-validation-campaign-ledger.json",
            "hash": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
            "role": "Campaign-by-campaign runtime closure plan for SPICE, Orekit, GMAT, Tudat, and OpenMDAO/Dymos evidence promotion."
          },
          {
            "id": "artifact-runtime-closure-packet",
            "label": "Runtime closure packet",
            "path": "public/runtime-closure-packet.json",
            "hash": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
            "role": "Operator-grade runtime closure packet with setup custody, commands, intake reports, acceptance checks, and fail-closed release impact."
          },
          {
            "id": "artifact-trajectory-validation-matrix",
            "label": "Trajectory validation matrix",
            "path": "public/trajectory-validation-matrix.json",
            "hash": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
            "role": "Decision-facing SPICE/Orekit/GMAT/Tudat validation matrix with current evidence state, independent-comparison requirements, residual frontier blockers, and scenario decision links."
          },
          {
            "id": "artifact-trajectory-residual-acceptance-ledger",
            "label": "Trajectory residual acceptance ledger",
            "path": "public/trajectory-residual-acceptance-ledger.json",
            "hash": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
            "role": "Fail-closed cross-tool residual acceptance lanes for Orekit/GMAT/Tudat/SPICE comparisons before trajectory evidence can affect scenario rankings."
          },
          {
            "id": "artifact-source-use-clearance-dossier",
            "label": "Source-use clearance dossier",
            "path": "public/source-use-clearance-dossier.json",
            "hash": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
            "role": "Customer/commercial source-use clearance workflow by source class, required approvals, redistribution boundaries, and fail-closed report-use decisions."
          },
          {
            "id": "artifact-scenario-decision-audit-ledger",
            "label": "Scenario decision audit ledger",
            "path": "public/scenario-decision-audit-ledger.json",
            "hash": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
            "role": "Scenario-by-scenario explanation of ranking drivers, flip conditions, assumption sensitivities, validation protocol refs, and proof burdens."
          },
          {
            "id": "artifact-scenario-crossover-frontier",
            "label": "Scenario crossover frontier",
            "path": "public/scenario-crossover-frontier.json",
            "hash": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
            "role": "Pairwise scenario utility gaps and explicit threshold paths showing what assumptions would need to change for a challenger scenario to win."
          },
          {
            "id": "artifact-scenario-uncertainty-budget-ledger",
            "label": "Scenario uncertainty budget ledger",
            "path": "public/scenario-uncertainty-budget-ledger.json",
            "hash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
            "role": "Scenario-by-scenario decomposition of modeled uncertainty, assumption blockers, runtime gaps, source-use risk, economics evidence, and resource ambiguity."
          },
          {
            "id": "artifact-scenario-decision-ledger",
            "label": "Scenario decision ledger",
            "path": "public/scenario-decision-ledger.json",
            "hash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
            "role": "Weighted driver decomposition, uncertainty, economics, blockers, and decision lane for every scenario."
          },
          {
            "id": "artifact-scenario-traceability-matrix",
            "label": "Scenario traceability matrix",
            "path": "public/scenario-traceability-matrix.json",
            "hash": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
            "role": "Scenario-by-scenario trace from rankings to assumptions, claims, sources, model runs, runtime sidecars, and blockers."
          },
          {
            "id": "artifact-evidence-gap-priority-ledger",
            "label": "Evidence gap priority ledger",
            "path": "public/evidence-gap-priority-ledger.json",
            "hash": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
            "role": "Ranked closure backlog for source, runtime, economics, resource, traceability, and release evidence gaps."
          },
          {
            "id": "artifact-promotion-closure-ledger",
            "label": "Promotion closure ledger",
            "path": "public/promotion-closure-ledger.json",
            "hash": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
            "role": "Executable closure plans for blocked science, resource, economics, materials, and model-validation promotion gates."
          },
          {
            "id": "artifact-economics-frontier",
            "label": "Economics frontier report",
            "path": "public/economics-frontier.json",
            "hash": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
            "role": "Seeded economics Monte Carlo, rank stability, funding coverage, and promotion blockers."
          },
          {
            "id": "artifact-economics-evidence-ledger",
            "label": "Economics evidence ledger",
            "path": "public/economics-evidence-ledger.json",
            "hash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
            "role": "Dated economics source surfaces, normalization requirements, model input references, and promotion gates."
          },
          {
            "id": "artifact-materials-process-evidence-ledger",
            "label": "Materials/process evidence ledger",
            "path": "public/materials-process-evidence-ledger.json",
            "hash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
            "role": "Process-by-process material property requirements, source references, scenario fit links, runtime artifact gaps, and promotion gates."
          },
          {
            "id": "artifact-space-environment-evidence-ledger",
            "label": "Space environment evidence ledger",
            "path": "public/space-environment-evidence-ledger.json",
            "hash": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
            "role": "SPDF/CDAWeb, CCMC, SWPC, DTN, and CCSDS source requirements, scenario stress links, runtime artifact gaps, and promotion gates."
          },
          {
            "id": "artifact-sidecar-readiness-ledger",
            "label": "Runtime sidecar readiness ledger",
            "path": "public/sidecar-readiness-ledger.json",
            "hash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
            "role": "Contract-by-contract runtime readiness, promoted artifacts, blocked prerequisites, preflight evidence, command templates, and next actions."
          },
          {
            "id": "artifact-workspace-ledger",
            "label": "Research workspace ledger",
            "path": "public/workspace-ledger.json",
            "hash": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
            "role": "Project/workspace binding for runs, claims, assumptions, notebooks, and review gates."
          },
          {
            "id": "artifact-model-artifacts",
            "label": "Model artifact bundle",
            "path": "public/model-artifacts.json",
            "hash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
            "role": "Source-backed model artifact records and promotion blockers."
          },
          {
            "id": "artifact-source-refresh",
            "label": "Source refresh evidence report",
            "path": "public/source-refresh-report.json",
            "hash": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
            "role": "Snapshot-first source refresh plan and review candidate checks."
          },
          {
            "id": "artifact-source-ingestion-ledger",
            "label": "Source ingestion work-order ledger",
            "path": "public/source-ingestion-ledger.json",
            "hash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
            "role": "Source-by-source ingestion contracts, required payload hashes, normalization gates, and promotion blockers."
          },
          {
            "id": "artifact-source-use-rights-ledger",
            "label": "Source use-rights ledger",
            "path": "public/source-use-rights-ledger.json",
            "hash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
            "role": "Source-by-source terms, citation, redistribution, provider-endorsement, and customer-use review gates."
          },
          {
            "id": "artifact-source-use-review-packets",
            "label": "Source use review packets",
            "path": "public/source-use-review-packets.json",
            "hash": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
            "role": "Per-source review packets for terms/license capture, citation approval, redistribution decisions, provider-endorsement boundaries, and customer-use approval."
          },
          {
            "id": "artifact-source-query-custody-ledger",
            "label": "Source query custody ledger",
            "path": "public/source-query-custody-ledger.json",
            "hash": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
            "role": "Provider query contracts, parser boundaries, unit maps, uncertainty maps, legal notes, and non-promotion rules for live source refresh candidates."
          },
          {
            "id": "artifact-sidecar-validation",
            "label": "Science sidecar validation gate",
            "path": "public/sidecar-validation-report.json",
            "hash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
            "role": "Fail-closed intake gate for SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts."
          },
          {
            "id": "artifact-sidecar-work-orders",
            "label": "Science sidecar execution packet",
            "path": "public/sidecar-work-orders.json",
            "hash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
            "role": "Executable work orders for external SPICE/Orekit/GMAT/Tudat/OpenMDAO workers."
          },
          {
            "id": "artifact-sidecar-run-specs",
            "label": "Science sidecar run specifications",
            "path": "public/sidecar-run-specs.json",
            "hash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
            "role": "Hash-backed execution specs, required inputs, acceptance gates, and non-evidence boundaries for external science workers."
          },
          {
            "id": "artifact-sidecar-artifact-templates",
            "label": "Science sidecar artifact templates",
            "path": "public/sidecar-artifact-templates.json",
            "hash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
            "role": "Fail-closed JSON templates showing the exact output shape external science workers must fill before sidecar intake."
          },
          {
            "id": "artifact-sidecar-scaffold-rejection-ledger",
            "label": "Science sidecar scaffold rejection ledger",
            "path": "public/sidecar-scaffold-rejection-ledger.json",
            "hash": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
            "role": "Hash-backed proof that Orekit, GMAT, and Tudat beta scaffolds are contract-traceable and intentionally blocked from promotion."
          },
          {
            "id": "workspace-workspace-investor-feasibility-brief",
            "label": "Investor Feasibility Brief",
            "path": "public/workspace-ledger.json",
            "hash": "sha256-39ce4c082cf5d7b374489dc8b8b7a54f6fb0192a04b3f993c9bc499629d3a035",
            "role": "Workspace-specific project, decision gate, review gates, and evidence hashes."
          },
          {
            "id": "run-run-hybrid-base-2026-06-19",
            "label": "Hybrid base feasibility run",
            "path": "public/model-run-ledger.json",
            "hash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
            "role": "Model run selected scenario: hybrid."
          },
          {
            "id": "run-run-conservative-moon-first-2026-06-19",
            "label": "Conservative Moon-first stress run",
            "path": "public/model-run-ledger.json",
            "hash": "sha256-f58e6bfe5aae47d6d92365d8b83e1843a5dbf18a3fd82cad81824110d7346601",
            "role": "Model run selected scenario: moon-first."
          }
        ],
        "evidenceHashes": {
          "feasibilityReport": "fnv1a32-5b0df6f9",
          "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "candidateSourceClosurePackets": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
          "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
          "capabilityMaturityLedger": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
          "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
          "workspaceLedger": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
          "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
          "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
          "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
          "scenarioDecisionDeltaLedger": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
          "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
          "scenarioNotebookPack": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
          "runtimeValidationCampaignLedger": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
          "runtimeClosurePacket": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
          "trajectoryValidationMatrix": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
          "trajectoryResidualAcceptanceLedger": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
          "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
          "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
          "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
          "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
          "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
          "promotionClosureLedger": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
          "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
          "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
          "spaceEnvironmentEvidenceLedger": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
          "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
          "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
          "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
          "sourceIngestionLedger": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
          "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "sourceUseReviewPacket": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
          "sourceUseClearanceDossier": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
          "sourceQueryCustodyLedger": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
          "customerReadinessContract": "sha256-f56b586ab243bb595075fe4fabd8d9a828a3dbfd2a9569ad6e7320b61389b6f3",
          "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
          "sidecarScaffoldRejectionLedger": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
          "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
          "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
          "sidecarArtifactTemplatePacket": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
          "includedArtifacts": "sha256-64ab60f11af2e3951f3a8aa565f22a1efef15adc624603d7e0f63d6daa7b03d2"
        }
      },
      "exportContract": {
        "filename": "customer-report-package-investor-feasibility-brief-v1.json",
        "requiredAttachments": [
          "packageHash",
          "customerReadinessContractHash",
          "reportPacketHash",
          "included artifact hashes",
          "blocked proof gates",
          "source-use boundary",
          "decision-delta acceptance state"
        ],
        "approvalRequired": [
          "owner approval",
          "source-use review approval",
          "runtime sidecar promotion approval",
          "workspace review approval",
          "customer wording approval"
        ],
        "blockedExportBoundary": "This packet can be exported for internal review and paid-beta scoping only. Customer/commercial delivery remains blocked until all proof gates pass."
      },
      "blockers": [
        "Claim promotion safe: 1 workspace claims remain unverified or blocked.",
        "Customer readiness proof gate is blocked: economics.",
        "Customer readiness proof gate is blocked: materials-process.",
        "Customer readiness proof gate is blocked: model-validation.",
        "Customer readiness proof gate is blocked: resource-candidates.",
        "Customer readiness proof gate is blocked: runtime-sidecars.",
        "Customer readiness proof gate is blocked: source-use-rights.",
        "Customer readiness proof gate is blocked: workspace-review.",
        "Decision-delta acceptance records are blocked until after-run artifacts exist.",
        "Economics evidence: Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads.",
        "Materials/process evidence: Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts.",
        "Materials/process records still lack promoted material payloads and runtime physics artifacts.",
        "Model validation protocols still have blocked commercial-use gates.",
        "Model validation: Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval.",
        "No runtime sidecar artifact has promoted; mission-design claims remain blocked.",
        "Resource candidates: Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim.",
        "Runtime sidecar validation: No SPICE/Orekit/GMAT/Tudat/OpenMDAO runtime sidecar artifacts have promoted.",
        "Runtime sidecars: Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight.",
        "Source use rights: Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source.",
        "Source-use rights review blocks customer/commercial report delivery.",
        "Workspace review: Workspace gates, selected runs, package scope, and reviewer approvals are closed."
      ],
      "nextActions": [
        "Attach approved after-run decision-delta artifacts before changing any customer-facing scenario answer.",
        "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
        "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
        "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
        "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
        "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
        "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
        "Normalize launch-cost records into model-ready numeric inputs with calibration artifacts.",
        "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
        "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing."
      ],
      "evidenceHashes": {
        "feasibilityReport": "fnv1a32-5b0df6f9",
        "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionDeltaLedger": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "packageHash": "sha256-8709add4b60e61a1e7e3f71c9339a266bddac45e4528d51bfcf643e9fcfa1ad3",
        "customerReadinessContract": "sha256-f56b586ab243bb595075fe4fabd8d9a828a3dbfd2a9569ad6e7320b61389b6f3"
      },
      "reportPacketHash": "sha256-4985a157ce5705893d4871f6dd454f3400371925267a0684f882ab65a59ab8a7"
    },
    {
      "id": "customer-report-packet-package-asteroid-feedstock-screen-v1",
      "packageId": "package-asteroid-feedstock-screen-v1",
      "title": "Asteroid Feedstock Screen Package Customer Report Packet",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "reportState": "beta-report-blocked",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "deliverableType": "source-gap-and-scenario-screen",
      "customerQuestion": "Which asteroid/feedstock assumptions are most fragile, and which legal public data would make a candidate worth deeper study?",
      "buyerFit": [
        "space resources startups",
        "university labs",
        "aerospace research teams"
      ],
      "executiveAnswer": {
        "selectedScenarioId": "hybrid",
        "selectedScenarioName": "Hybrid Moon -> Asteroid -> Mercury",
        "topDecisionScenarioId": "moon-first",
        "confidenceBand": "research-backlog-confidence",
        "currentAnswer": "Use the current ranking as decision support only; it is not a mission design, verified resource claim, or cleared customer report until the listed gates close.",
        "buyerFacingValue": "Converts public science, engineering, economics, and source-rights evidence into reproducible scenario comparisons with explicit uncertainty and blockers.",
        "sellableBetaLane": "paid-beta-internal-diligence-with-citation-review",
        "commercializationAllowed": false
      },
      "readerSections": [
        {
          "id": "executive-answer",
          "title": "Executive answer",
          "status": "decision-support-only",
          "contentBoundary": "May describe current model output and uncertainty, but cannot be presented as validated mission design or cleared commercial advice."
        },
        {
          "id": "scenario-comparison",
          "title": "Scenario comparison",
          "status": "hash-backed-beta",
          "contentBoundary": "Must show ranked scenarios, uncertainty, proof-to-change-answer, and why Mercury-first is not hardcoded."
        },
        {
          "id": "evidence-and-blockers",
          "title": "Evidence and blockers",
          "status": "required",
          "contentBoundary": "Must include source-use, runtime sidecar, economics, resource, materials/process, workspace, and reviewer blockers."
        },
        {
          "id": "diligence-work-orders",
          "title": "Diligence work orders",
          "status": "paid-beta-scope",
          "contentBoundary": "May be sold as scoped diligence work; cannot be sold as proof until after-run delta acceptance records pass."
        }
      ],
      "scenarioBriefs": [
        {
          "scenarioId": "asteroid-first",
          "dossierId": "customer-dossier-asteroid-first",
          "name": "Asteroid Feedstock-first",
          "customerUseState": "research-backlog-only",
          "decisionLane": "lane-4-research-backlog",
          "decisionReadinessScore": 41.63,
          "uncertaintyBudgetPoints": 62.38,
          "proofToChangeAnswer": {
            "crossoverId": "crossover-asteroid-first-over-moon-first",
            "challengerScenarioId": "asteroid-first",
            "currentLeaderScenarioId": "moon-first",
            "requiredUtilityDelta": 15.75,
            "crossoverState": "outside-single-lever-range",
            "topLeverPaths": [
              {
                "kind": "uncertainty-reduction",
                "criterion": "uncertaintyPenalty",
                "currentValue": 18,
                "direction": "decrease",
                "utilityPerPoint": 0.42,
                "requiredRawDelta": 37.5,
                "feasibleByRawRange": false,
                "headroom": 18
              },
              {
                "kind": "risk-reduction",
                "criterion": "transport",
                "currentValue": 58,
                "direction": "decrease",
                "utilityPerPoint": 0.1378,
                "requiredRawDelta": 114.31,
                "feasibleByRawRange": false,
                "headroom": 58
              },
              {
                "kind": "risk-reduction",
                "criterion": "feedstock",
                "currentValue": 72,
                "direction": "decrease",
                "utilityPerPoint": 0.1378,
                "requiredRawDelta": 114.31,
                "feasibleByRawRange": false,
                "headroom": 72
              }
            ],
            "crossoverHash": "sha256-14d2ba998f0843e1cdd3b05e6b5d598c9fb1800b385852c58702ed5ca16e6451"
          },
          "topBlockers": [
            "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
            "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
            "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
            "orekit-propagation-v1 runtime evidence missing for asteroid-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound."
          ],
          "nextProofActions": [
            "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
            "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "Approve source-use review packets before customer-facing redistribution or derived-value claims."
          ],
          "dossierHash": "sha256-562059664eb4f97f063fe279404557707fb81da4e4e575591d06ed2b89aad2b1"
        },
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "customerUseState": "research-backlog-only",
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "proofToChangeAnswer": {
            "crossoverId": "crossover-hybrid-over-moon-first",
            "challengerScenarioId": "hybrid",
            "currentLeaderScenarioId": "moon-first",
            "requiredUtilityDelta": 1.43,
            "crossoverState": "mathematically-reachable-not-validated",
            "topLeverPaths": [
              {
                "kind": "uncertainty-reduction",
                "criterion": "uncertaintyPenalty",
                "currentValue": 12,
                "direction": "decrease",
                "utilityPerPoint": 0.42,
                "requiredRawDelta": 3.4,
                "feasibleByRawRange": true,
                "headroom": 12
              },
              {
                "kind": "risk-reduction",
                "criterion": "transport",
                "currentValue": 46,
                "direction": "decrease",
                "utilityPerPoint": 0.1378,
                "requiredRawDelta": 10.38,
                "feasibleByRawRange": true,
                "headroom": 46
              },
              {
                "kind": "risk-reduction",
                "criterion": "feedstock",
                "currentValue": 55,
                "direction": "decrease",
                "utilityPerPoint": 0.1378,
                "requiredRawDelta": 10.38,
                "feasibleByRawRange": true,
                "headroom": 55
              }
            ],
            "crossoverHash": "sha256-3f18573eaa49677e7506a5604e505ffe279334d0b5f95dcfa82fd24a47342916"
          },
          "topBlockers": [
            "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
            "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
            "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
            "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound."
          ],
          "nextProofActions": [
            "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
            "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "Approve source-use review packets before customer-facing redistribution or derived-value claims."
          ],
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
        }
      ],
      "diligenceWorkOrders": [
        {
          "id": "diligence-work-order-06-gap-candidate-source-2026-em",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
          "workOrderHash": "sha256-ca289d3590ea16900ade0899719bc6f367b45d272c91c2e61f4110ea941a5e16"
        },
        {
          "id": "diligence-work-order-07-gap-candidate-source-2026-jm2",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
          "workOrderHash": "sha256-708045573dcd7b1b11a8d0644a1306575d7ae399481f6842235f66802c679332"
        },
        {
          "id": "diligence-work-order-08-gap-candidate-source-2026-dn5",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
          "workOrderHash": "sha256-7aba6c179ff641753e4dcf699a4c2e196f07d7a2ebadbb931690035802d2f143"
        },
        {
          "id": "diligence-work-order-11-gap-resource-taxonomy-spectra-record",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
          "workOrderHash": "sha256-ce13be2de8e222b90b3f72ab64e82567f72bc328ddf50d0cdf34b08ecf7cd089"
        }
      ],
      "decisionDeltaAcceptance": [
        {
          "id": "decision-delta-diligence-work-order-06-gap-candidate-source-2026-em",
          "workOrderId": "diligence-work-order-06-gap-candidate-source-2026-em",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-e80560acfdc667dad2bc92f845f13cd8b86102818332de3fb04474fcbcda5b5a"
        },
        {
          "id": "decision-delta-diligence-work-order-07-gap-candidate-source-2026-jm2",
          "workOrderId": "diligence-work-order-07-gap-candidate-source-2026-jm2",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-773d432f747db4658c55e62bf6391a5a0810a3656b643105ca7748704fe78898"
        },
        {
          "id": "decision-delta-diligence-work-order-08-gap-candidate-source-2026-dn5",
          "workOrderId": "diligence-work-order-08-gap-candidate-source-2026-dn5",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-21f28e19a52de7ba3e8f2e9a5044ace620f6e821196ba50698501bdedd753f40"
        },
        {
          "id": "decision-delta-diligence-work-order-11-gap-resource-taxonomy-spectra-record",
          "workOrderId": "diligence-work-order-11-gap-resource-taxonomy-spectra-record",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-a7d57999cd5183edec36a6a8900ac7bd7618bbe6be4ee0c9de0241042489605e"
        }
      ],
      "proofGates": [
        {
          "id": "source-use-rights",
          "label": "Source use rights",
          "status": "blocked",
          "evidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "requiredProof": "Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source."
        },
        {
          "id": "runtime-sidecars",
          "label": "Runtime sidecars",
          "status": "blocked",
          "evidenceHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
          "requiredProof": "Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight."
        },
        {
          "id": "model-validation",
          "label": "Model validation",
          "status": "blocked",
          "evidenceHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
          "requiredProof": "Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval."
        },
        {
          "id": "resource-candidates",
          "label": "Resource candidates",
          "status": "blocked",
          "evidenceHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
          "requiredProof": "Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim."
        },
        {
          "id": "economics",
          "label": "Economics evidence",
          "status": "blocked",
          "evidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "requiredProof": "Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads."
        },
        {
          "id": "materials-process",
          "label": "Materials/process evidence",
          "status": "blocked",
          "evidenceHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
          "requiredProof": "Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts."
        },
        {
          "id": "workspace-review",
          "label": "Workspace review",
          "status": "blocked",
          "evidenceHash": "sha256-af632045750b3b113f57cdad025a4ea3fe74018460b743bcf69eff71fee3b709",
          "requiredProof": "Workspace gates, selected runs, package scope, and reviewer approvals are closed."
        }
      ],
      "blockedProofGates": [
        {
          "id": "source-use-rights",
          "label": "Source use rights",
          "status": "blocked",
          "requiredProof": "Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source.",
          "evidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
        },
        {
          "id": "runtime-sidecars",
          "label": "Runtime sidecars",
          "status": "blocked",
          "requiredProof": "Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight.",
          "evidenceHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
        },
        {
          "id": "model-validation",
          "label": "Model validation",
          "status": "blocked",
          "requiredProof": "Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval.",
          "evidenceHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
        },
        {
          "id": "resource-candidates",
          "label": "Resource candidates",
          "status": "blocked",
          "requiredProof": "Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim.",
          "evidenceHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608"
        },
        {
          "id": "economics",
          "label": "Economics evidence",
          "status": "blocked",
          "requiredProof": "Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads.",
          "evidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297"
        },
        {
          "id": "materials-process",
          "label": "Materials/process evidence",
          "status": "blocked",
          "requiredProof": "Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts.",
          "evidenceHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80"
        },
        {
          "id": "workspace-review",
          "label": "Workspace review",
          "status": "blocked",
          "requiredProof": "Workspace gates, selected runs, package scope, and reviewer approvals are closed.",
          "evidenceHash": "sha256-af632045750b3b113f57cdad025a4ea3fe74018460b743bcf69eff71fee3b709"
        }
      ],
      "blockedClaims": [
        "No operational mission design, launch commitment, or flight-dynamics certification.",
        "No asteroid or planetary resource-composition claim without candidate-specific taxonomy, spectra, mission, or sample evidence.",
        "No commercial economics, throughput, process-quality, or manufacturability claim while economics/materials/process ledgers are blocked.",
        "No customer-facing trajectory/event-window claim until the full required runtime set and independent validation gates pass.",
        "No raw source redistribution or customer commercial use until source-use rights review passes."
      ],
      "allowedClaims": [
        "Source-backed beta context claims may be cited only with evidence hashes attached.",
        "Scenario rankings may be used as decision-support heuristics with uncertainty and blocker context visible.",
        "Evidence-gap, crossover, and diligence priorities may be used to scope paid research work."
      ],
      "evidenceAppendix": {
        "packageHash": "sha256-168164a372d0887c73fed0a816b44b4ccb4e19bf68111035cb8d7ea47a48a93a",
        "customerReadinessContractHash": "sha256-af2fd31db2e74998866192ad6e50e6f6f113fa06c30f185583d9ca527451472f",
        "includedArtifactCount": 47,
        "artifactRefs": [
          {
            "id": "artifact-scenario-diligence-work-order-ledger",
            "label": "Scenario diligence work-order ledger",
            "path": "public/scenario-diligence-work-order-ledger.json",
            "hash": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
            "role": "Customer/package-linked diligence work orders, acceptance gates, affected scenarios, replay commands, and decision-delta requirements."
          },
          {
            "id": "artifact-scenario-decision-delta-ledger",
            "label": "Scenario decision delta ledger",
            "path": "public/scenario-decision-delta-ledger.json",
            "hash": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
            "role": "Fail-closed before/after acceptance records proving no diligence work order can change a customer answer without a hashed after-run artifact."
          },
          {
            "id": "artifact-customer-decision-dossier-ledger",
            "label": "Customer decision dossier ledger",
            "path": "public/customer-decision-dossier-ledger.json",
            "hash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
            "role": "Scenario-by-scenario customer-use state, buyer boundary, evidence summary, blockers, proof-to-change-answer, and next proof actions."
          },
          {
            "id": "artifact-model-validation-protocols",
            "label": "Model validation protocol ledger",
            "path": "public/model-validation-protocols.json",
            "hash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
            "role": "Domain-by-domain validation protocols, acceptance criteria, source/runtime gates, blocker states, and commercial-use boundaries."
          },
          {
            "id": "artifact-asteroid-candidate-evidence-ledger",
            "label": "Asteroid candidate evidence ledger",
            "path": "public/asteroid-candidate-evidence-ledger.json",
            "hash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
            "role": "Candidate-level SBDB/CAD/MPC/taxonomy/spectra evidence requirements, blockers, and resource-promotion gates."
          },
          {
            "id": "artifact-candidate-source-promotion-ledger",
            "label": "Candidate source promotion ledger",
            "path": "public/candidate-source-promotion-ledger.json",
            "hash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
            "role": "Candidate work-order source custody, resource-promotion, customer-use gates, report intake state, and explicit work-order gaps."
          },
          {
            "id": "artifact-candidate-source-closure-packets",
            "label": "Candidate source closure packets",
            "path": "public/candidate-source-closure-packets.json",
            "hash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
            "role": "Executable candidate-by-candidate closure packets with missing MPC, review, composition, and customer-use acceptance gates."
          },
          {
            "id": "artifact-capability-maturity-ledger",
            "label": "Capability maturity ledger",
            "path": "public/capability-maturity-ledger.json",
            "hash": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
            "role": "Business capability maturity, source coverage, model coverage, sidecar blockers, and commercialization gates."
          },
          {
            "id": "artifact-claim-evidence-ledger",
            "label": "Claim evidence ledger",
            "path": "public/claim-evidence-ledger.json",
            "hash": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
            "role": "Claim-level source coverage, confidence, promotion gates, allowed use, and blockers."
          },
          {
            "id": "artifact-feasibility-report",
            "label": "Canonical feasibility report",
            "path": "public/feasibility-report.json",
            "hash": "fnv1a32-5b0df6f9",
            "role": "Executive scenario comparison and governance summary."
          },
          {
            "id": "artifact-model-run-ledger",
            "label": "Versioned model-run ledger",
            "path": "public/model-run-ledger.json",
            "hash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
            "role": "Reproducible run inputs, uncertainty settings, rankings, and run hashes."
          },
          {
            "id": "artifact-model-run-comparison-ledger",
            "label": "Model-run comparison ledger",
            "path": "public/model-run-comparison-ledger.json",
            "hash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
            "role": "Run-to-run selected-scenario, rank-one, utility, uncertainty, business-readiness, and replay-boundary deltas."
          },
          {
            "id": "artifact-assumption-impact-ledger",
            "label": "Assumption impact ledger",
            "path": "public/assumption-impact-ledger.json",
            "hash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
            "role": "Assumption-to-scenario sensitivity, source coverage, stress behavior, and promotion gates."
          },
          {
            "id": "artifact-scenario-comparison-board",
            "label": "Scenario comparison board",
            "path": "public/scenario-comparison-board.json",
            "hash": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
            "role": "Business-grade scenario comparison board with decision score, uncertainty budget, economics, traceability, blockers, and CSV/Markdown export hashes."
          },
          {
            "id": "artifact-scenario-notebook-pack",
            "label": "Scenario notebook pack",
            "path": "public/scenario-notebook-pack.json",
            "hash": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
            "role": "Scenario-by-scenario reviewer notebooks with source coverage, open questions, blockers, work orders, and Markdown export hashes."
          },
          {
            "id": "artifact-runtime-validation-campaign-ledger",
            "label": "Runtime validation campaign ledger",
            "path": "public/runtime-validation-campaign-ledger.json",
            "hash": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
            "role": "Campaign-by-campaign runtime closure plan for SPICE, Orekit, GMAT, Tudat, and OpenMDAO/Dymos evidence promotion."
          },
          {
            "id": "artifact-runtime-closure-packet",
            "label": "Runtime closure packet",
            "path": "public/runtime-closure-packet.json",
            "hash": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
            "role": "Operator-grade runtime closure packet with setup custody, commands, intake reports, acceptance checks, and fail-closed release impact."
          },
          {
            "id": "artifact-trajectory-validation-matrix",
            "label": "Trajectory validation matrix",
            "path": "public/trajectory-validation-matrix.json",
            "hash": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
            "role": "Decision-facing SPICE/Orekit/GMAT/Tudat validation matrix with current evidence state, independent-comparison requirements, residual frontier blockers, and scenario decision links."
          },
          {
            "id": "artifact-trajectory-residual-acceptance-ledger",
            "label": "Trajectory residual acceptance ledger",
            "path": "public/trajectory-residual-acceptance-ledger.json",
            "hash": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
            "role": "Fail-closed cross-tool residual acceptance lanes for Orekit/GMAT/Tudat/SPICE comparisons before trajectory evidence can affect scenario rankings."
          },
          {
            "id": "artifact-source-use-clearance-dossier",
            "label": "Source-use clearance dossier",
            "path": "public/source-use-clearance-dossier.json",
            "hash": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
            "role": "Customer/commercial source-use clearance workflow by source class, required approvals, redistribution boundaries, and fail-closed report-use decisions."
          },
          {
            "id": "artifact-scenario-decision-audit-ledger",
            "label": "Scenario decision audit ledger",
            "path": "public/scenario-decision-audit-ledger.json",
            "hash": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
            "role": "Scenario-by-scenario explanation of ranking drivers, flip conditions, assumption sensitivities, validation protocol refs, and proof burdens."
          },
          {
            "id": "artifact-scenario-crossover-frontier",
            "label": "Scenario crossover frontier",
            "path": "public/scenario-crossover-frontier.json",
            "hash": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
            "role": "Pairwise scenario utility gaps and explicit threshold paths showing what assumptions would need to change for a challenger scenario to win."
          },
          {
            "id": "artifact-scenario-uncertainty-budget-ledger",
            "label": "Scenario uncertainty budget ledger",
            "path": "public/scenario-uncertainty-budget-ledger.json",
            "hash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
            "role": "Scenario-by-scenario decomposition of modeled uncertainty, assumption blockers, runtime gaps, source-use risk, economics evidence, and resource ambiguity."
          },
          {
            "id": "artifact-scenario-decision-ledger",
            "label": "Scenario decision ledger",
            "path": "public/scenario-decision-ledger.json",
            "hash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
            "role": "Weighted driver decomposition, uncertainty, economics, blockers, and decision lane for every scenario."
          },
          {
            "id": "artifact-scenario-traceability-matrix",
            "label": "Scenario traceability matrix",
            "path": "public/scenario-traceability-matrix.json",
            "hash": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
            "role": "Scenario-by-scenario trace from rankings to assumptions, claims, sources, model runs, runtime sidecars, and blockers."
          },
          {
            "id": "artifact-evidence-gap-priority-ledger",
            "label": "Evidence gap priority ledger",
            "path": "public/evidence-gap-priority-ledger.json",
            "hash": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
            "role": "Ranked closure backlog for source, runtime, economics, resource, traceability, and release evidence gaps."
          },
          {
            "id": "artifact-promotion-closure-ledger",
            "label": "Promotion closure ledger",
            "path": "public/promotion-closure-ledger.json",
            "hash": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
            "role": "Executable closure plans for blocked science, resource, economics, materials, and model-validation promotion gates."
          },
          {
            "id": "artifact-economics-frontier",
            "label": "Economics frontier report",
            "path": "public/economics-frontier.json",
            "hash": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
            "role": "Seeded economics Monte Carlo, rank stability, funding coverage, and promotion blockers."
          },
          {
            "id": "artifact-economics-evidence-ledger",
            "label": "Economics evidence ledger",
            "path": "public/economics-evidence-ledger.json",
            "hash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
            "role": "Dated economics source surfaces, normalization requirements, model input references, and promotion gates."
          },
          {
            "id": "artifact-materials-process-evidence-ledger",
            "label": "Materials/process evidence ledger",
            "path": "public/materials-process-evidence-ledger.json",
            "hash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
            "role": "Process-by-process material property requirements, source references, scenario fit links, runtime artifact gaps, and promotion gates."
          },
          {
            "id": "artifact-space-environment-evidence-ledger",
            "label": "Space environment evidence ledger",
            "path": "public/space-environment-evidence-ledger.json",
            "hash": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
            "role": "SPDF/CDAWeb, CCMC, SWPC, DTN, and CCSDS source requirements, scenario stress links, runtime artifact gaps, and promotion gates."
          },
          {
            "id": "artifact-sidecar-readiness-ledger",
            "label": "Runtime sidecar readiness ledger",
            "path": "public/sidecar-readiness-ledger.json",
            "hash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
            "role": "Contract-by-contract runtime readiness, promoted artifacts, blocked prerequisites, preflight evidence, command templates, and next actions."
          },
          {
            "id": "artifact-workspace-ledger",
            "label": "Research workspace ledger",
            "path": "public/workspace-ledger.json",
            "hash": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
            "role": "Project/workspace binding for runs, claims, assumptions, notebooks, and review gates."
          },
          {
            "id": "artifact-model-artifacts",
            "label": "Model artifact bundle",
            "path": "public/model-artifacts.json",
            "hash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
            "role": "Source-backed model artifact records and promotion blockers."
          },
          {
            "id": "artifact-source-refresh",
            "label": "Source refresh evidence report",
            "path": "public/source-refresh-report.json",
            "hash": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
            "role": "Snapshot-first source refresh plan and review candidate checks."
          },
          {
            "id": "artifact-source-ingestion-ledger",
            "label": "Source ingestion work-order ledger",
            "path": "public/source-ingestion-ledger.json",
            "hash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
            "role": "Source-by-source ingestion contracts, required payload hashes, normalization gates, and promotion blockers."
          },
          {
            "id": "artifact-source-use-rights-ledger",
            "label": "Source use-rights ledger",
            "path": "public/source-use-rights-ledger.json",
            "hash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
            "role": "Source-by-source terms, citation, redistribution, provider-endorsement, and customer-use review gates."
          },
          {
            "id": "artifact-source-use-review-packets",
            "label": "Source use review packets",
            "path": "public/source-use-review-packets.json",
            "hash": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
            "role": "Per-source review packets for terms/license capture, citation approval, redistribution decisions, provider-endorsement boundaries, and customer-use approval."
          },
          {
            "id": "artifact-source-query-custody-ledger",
            "label": "Source query custody ledger",
            "path": "public/source-query-custody-ledger.json",
            "hash": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
            "role": "Provider query contracts, parser boundaries, unit maps, uncertainty maps, legal notes, and non-promotion rules for live source refresh candidates."
          },
          {
            "id": "artifact-sidecar-validation",
            "label": "Science sidecar validation gate",
            "path": "public/sidecar-validation-report.json",
            "hash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
            "role": "Fail-closed intake gate for SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts."
          },
          {
            "id": "artifact-sidecar-work-orders",
            "label": "Science sidecar execution packet",
            "path": "public/sidecar-work-orders.json",
            "hash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
            "role": "Executable work orders for external SPICE/Orekit/GMAT/Tudat/OpenMDAO workers."
          },
          {
            "id": "artifact-sidecar-run-specs",
            "label": "Science sidecar run specifications",
            "path": "public/sidecar-run-specs.json",
            "hash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
            "role": "Hash-backed execution specs, required inputs, acceptance gates, and non-evidence boundaries for external science workers."
          },
          {
            "id": "artifact-sidecar-artifact-templates",
            "label": "Science sidecar artifact templates",
            "path": "public/sidecar-artifact-templates.json",
            "hash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
            "role": "Fail-closed JSON templates showing the exact output shape external science workers must fill before sidecar intake."
          },
          {
            "id": "artifact-sidecar-scaffold-rejection-ledger",
            "label": "Science sidecar scaffold rejection ledger",
            "path": "public/sidecar-scaffold-rejection-ledger.json",
            "hash": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
            "role": "Hash-backed proof that Orekit, GMAT, and Tudat beta scaffolds are contract-traceable and intentionally blocked from promotion."
          },
          {
            "id": "workspace-workspace-asteroid-feedstock-screen",
            "label": "Asteroid Feedstock Screen",
            "path": "public/workspace-ledger.json",
            "hash": "sha256-af632045750b3b113f57cdad025a4ea3fe74018460b743bcf69eff71fee3b709",
            "role": "Workspace-specific project, decision gate, review gates, and evidence hashes."
          },
          {
            "id": "run-run-asteroid-feedstock-probe-2026-06-19",
            "label": "Asteroid feedstock uncertainty probe",
            "path": "public/model-run-ledger.json",
            "hash": "sha256-68cd75732797695c5aecb33617bd5132129608750a763e4c998d9e22bf4d1b22",
            "role": "Model run selected scenario: asteroid-first."
          },
          {
            "id": "run-run-hybrid-base-2026-06-19",
            "label": "Hybrid base feasibility run",
            "path": "public/model-run-ledger.json",
            "hash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
            "role": "Model run selected scenario: hybrid."
          }
        ],
        "evidenceHashes": {
          "feasibilityReport": "fnv1a32-5b0df6f9",
          "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "candidateSourceClosurePackets": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
          "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
          "capabilityMaturityLedger": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
          "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
          "workspaceLedger": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
          "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
          "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
          "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
          "scenarioDecisionDeltaLedger": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
          "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
          "scenarioNotebookPack": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
          "runtimeValidationCampaignLedger": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
          "runtimeClosurePacket": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
          "trajectoryValidationMatrix": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
          "trajectoryResidualAcceptanceLedger": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
          "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
          "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
          "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
          "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
          "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
          "promotionClosureLedger": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
          "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
          "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
          "spaceEnvironmentEvidenceLedger": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
          "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
          "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
          "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
          "sourceIngestionLedger": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
          "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "sourceUseReviewPacket": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
          "sourceUseClearanceDossier": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
          "sourceQueryCustodyLedger": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
          "customerReadinessContract": "sha256-af2fd31db2e74998866192ad6e50e6f6f113fa06c30f185583d9ca527451472f",
          "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
          "sidecarScaffoldRejectionLedger": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
          "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
          "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
          "sidecarArtifactTemplatePacket": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
          "includedArtifacts": "sha256-0ce10bcc41ec6b23edf761c5d87c38b58e957642116cf42cb757a18e3aefe564"
        }
      },
      "exportContract": {
        "filename": "customer-report-package-asteroid-feedstock-screen-v1.json",
        "requiredAttachments": [
          "packageHash",
          "customerReadinessContractHash",
          "reportPacketHash",
          "included artifact hashes",
          "blocked proof gates",
          "source-use boundary",
          "decision-delta acceptance state"
        ],
        "approvalRequired": [
          "owner approval",
          "source-use review approval",
          "runtime sidecar promotion approval",
          "workspace review approval",
          "customer wording approval"
        ],
        "blockedExportBoundary": "This packet can be exported for internal review and paid-beta scoping only. Customer/commercial delivery remains blocked until all proof gates pass."
      },
      "blockers": [
        "Claim promotion safe: 2 workspace claims remain unverified or blocked.",
        "Customer readiness proof gate is blocked: economics.",
        "Customer readiness proof gate is blocked: materials-process.",
        "Customer readiness proof gate is blocked: model-validation.",
        "Customer readiness proof gate is blocked: resource-candidates.",
        "Customer readiness proof gate is blocked: runtime-sidecars.",
        "Customer readiness proof gate is blocked: source-use-rights.",
        "Customer readiness proof gate is blocked: workspace-review.",
        "Decision-delta acceptance records are blocked until after-run artifacts exist.",
        "Economics evidence: Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads.",
        "Materials/process evidence: Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts.",
        "Materials/process records still lack promoted material payloads and runtime physics artifacts.",
        "Model validation protocols still have blocked commercial-use gates.",
        "Model validation: Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval.",
        "No runtime sidecar artifact has promoted; mission-design claims remain blocked.",
        "Resource candidates: Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim.",
        "Runtime sidecar validation: No SPICE/Orekit/GMAT/Tudat/OpenMDAO runtime sidecar artifacts have promoted.",
        "Runtime sidecars: Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight.",
        "Source use rights: Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source.",
        "Source-use rights review blocks customer/commercial report delivery.",
        "Workspace review: Workspace gates, selected runs, package scope, and reviewer approvals are closed."
      ],
      "nextActions": [
        "Attach approved after-run decision-delta artifacts before changing any customer-facing scenario answer.",
        "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
        "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
        "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
        "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
        "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
        "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
        "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
        "Source data is not normalized into model-ready numeric inputs."
      ],
      "evidenceHashes": {
        "feasibilityReport": "fnv1a32-5b0df6f9",
        "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionDeltaLedger": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "packageHash": "sha256-168164a372d0887c73fed0a816b44b4ccb4e19bf68111035cb8d7ea47a48a93a",
        "customerReadinessContract": "sha256-af2fd31db2e74998866192ad6e50e6f6f113fa06c30f185583d9ca527451472f"
      },
      "reportPacketHash": "sha256-7da7883c9760a2758063e3c19bb1f01a06ee79c8cf36404b75acca8436fe35d1"
    },
    {
      "id": "customer-report-packet-package-science-validation-backlog-v1",
      "packageId": "package-science-validation-backlog-v1",
      "title": "Science Validation Backlog Package Customer Report Packet",
      "generatedAt": "2026-06-21T00:00:00.000Z",
      "reportState": "beta-report-blocked",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "deliverableType": "engineering-validation-roadmap",
      "customerQuestion": "Which runtime science artifacts must be generated before trajectory, event-window, or optimization claims can promote?",
      "buyerFit": [
        "internal engineering",
        "scientific advisors",
        "technical diligence reviewers"
      ],
      "executiveAnswer": {
        "selectedScenarioId": "hybrid",
        "selectedScenarioName": "Hybrid Moon -> Asteroid -> Mercury",
        "topDecisionScenarioId": "moon-first",
        "confidenceBand": "research-backlog-confidence",
        "currentAnswer": "Use the current ranking as decision support only; it is not a mission design, verified resource claim, or cleared customer report until the listed gates close.",
        "buyerFacingValue": "Converts public science, engineering, economics, and source-rights evidence into reproducible scenario comparisons with explicit uncertainty and blockers.",
        "sellableBetaLane": "paid-beta-internal-diligence-with-citation-review",
        "commercializationAllowed": false
      },
      "readerSections": [
        {
          "id": "executive-answer",
          "title": "Executive answer",
          "status": "decision-support-only",
          "contentBoundary": "May describe current model output and uncertainty, but cannot be presented as validated mission design or cleared commercial advice."
        },
        {
          "id": "scenario-comparison",
          "title": "Scenario comparison",
          "status": "hash-backed-beta",
          "contentBoundary": "Must show ranked scenarios, uncertainty, proof-to-change-answer, and why Mercury-first is not hardcoded."
        },
        {
          "id": "evidence-and-blockers",
          "title": "Evidence and blockers",
          "status": "required",
          "contentBoundary": "Must include source-use, runtime sidecar, economics, resource, materials/process, workspace, and reviewer blockers."
        },
        {
          "id": "diligence-work-orders",
          "title": "Diligence work orders",
          "status": "paid-beta-scope",
          "contentBoundary": "May be sold as scoped diligence work; cannot be sold as proof until after-run delta acceptance records pass."
        }
      ],
      "scenarioBriefs": [
        {
          "scenarioId": "hybrid",
          "dossierId": "customer-dossier-hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "customerUseState": "research-backlog-only",
          "decisionLane": "lane-3-watchlist",
          "decisionReadinessScore": 59.78,
          "uncertaintyBudgetPoints": 43.88,
          "proofToChangeAnswer": {
            "crossoverId": "crossover-hybrid-over-moon-first",
            "challengerScenarioId": "hybrid",
            "currentLeaderScenarioId": "moon-first",
            "requiredUtilityDelta": 1.43,
            "crossoverState": "mathematically-reachable-not-validated",
            "topLeverPaths": [
              {
                "kind": "uncertainty-reduction",
                "criterion": "uncertaintyPenalty",
                "currentValue": 12,
                "direction": "decrease",
                "utilityPerPoint": 0.42,
                "requiredRawDelta": 3.4,
                "feasibleByRawRange": true,
                "headroom": 12
              },
              {
                "kind": "risk-reduction",
                "criterion": "transport",
                "currentValue": 46,
                "direction": "decrease",
                "utilityPerPoint": 0.1378,
                "requiredRawDelta": 10.38,
                "feasibleByRawRange": true,
                "headroom": 46
              },
              {
                "kind": "risk-reduction",
                "criterion": "feedstock",
                "currentValue": 55,
                "direction": "decrease",
                "utilityPerPoint": 0.1378,
                "requiredRawDelta": 10.38,
                "feasibleByRawRange": true,
                "headroom": 55
              }
            ],
            "crossoverHash": "sha256-3f18573eaa49677e7506a5604e505ffe279334d0b5f95dcfa82fd24a47342916"
          },
          "topBlockers": [
            "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
            "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
            "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
            "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound."
          ],
          "nextProofActions": [
            "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
            "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "Approve source-use review packets before customer-facing redistribution or derived-value claims."
          ],
          "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
        }
      ],
      "diligenceWorkOrders": [
        {
          "id": "diligence-work-order-01-gap-runtime-orekit-propagation-v1",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "workOrderHash": "sha256-baa82fd4ea74aad62b55dfc56fd78e1513cac8ba3a0e6cbc136c02b3d128e4d1"
        },
        {
          "id": "diligence-work-order-02-gap-runtime-gmat-transfer-v1",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "workOrderHash": "sha256-571ba2ce848959e9016799486d0505720f857685f02a601c2cc09e7f58a3e476"
        },
        {
          "id": "diligence-work-order-03-gap-runtime-tudat-transfer-v1",
          "lane": "runtime-validation",
          "priorityLane": "P0-critical-path",
          "buyerQuestion": "Can the mission-design and event-window assumptions survive reproducible SPICE/Orekit/GMAT/Tudat evidence?",
          "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "workOrderHash": "sha256-74ae877ca9b3c8c030f093f9b35cfd3239f6069c924c1f0da02bf9b6c1d98710"
        },
        {
          "id": "diligence-work-order-04-gap-materials-process-oxygen-isru",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
          "workOrderHash": "sha256-bdf99d78b39494df13a8409aa9336affd690e24fd93ec58fdc5b56e258143622"
        },
        {
          "id": "diligence-work-order-05-gap-readiness-science-math-credibility",
          "lane": "release-proof",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Required to raise the beta from testable to release-grade.",
          "nextAction": "Source Registry 2.0, assumption registry, scenario notebooks, generated model-artifact bundles, seeded scenario uncertainty analysis, generated economics frontier artifacts, business-case planning heuristics, one SPICE GF runtime artifact, and one OpenMDAO/Dymos beta optimization artifact are now local and tested, but Orekit/GMAT/Tudat runtime artifacts are not yet generated.",
          "workOrderHash": "sha256-6e0809c818212af1f7017609be842f01e31c381d04b54fc7f66db8f75606e2d6"
        },
        {
          "id": "diligence-work-order-06-gap-candidate-source-2026-em",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
          "workOrderHash": "sha256-ca289d3590ea16900ade0899719bc6f367b45d272c91c2e61f4110ea941a5e16"
        },
        {
          "id": "diligence-work-order-07-gap-candidate-source-2026-jm2",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
          "workOrderHash": "sha256-708045573dcd7b1b11a8d0644a1306575d7ae399481f6842235f66802c679332"
        },
        {
          "id": "diligence-work-order-08-gap-candidate-source-2026-dn5",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
          "workOrderHash": "sha256-7aba6c179ff641753e4dcf699a4c2e196f07d7a2ebadbb931690035802d2f143"
        },
        {
          "id": "diligence-work-order-09-gap-materials-process-spf-db",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and thermal cycle energy balance for Superplastic Forming / Diffusion Bonding.",
          "workOrderHash": "sha256-0f76d2cba16f3e50d606a4ca6ba58e7b0b55ff94806314a9f1fc37a2016034b4"
        },
        {
          "id": "diligence-work-order-10-gap-materials-process-vacuum-sheet",
          "lane": "process-physics",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can material/process physics support the manufacturing claim under the target body environment?",
          "nextAction": "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing.",
          "workOrderHash": "sha256-ef9e747934d358294e2459299e33ef07454fd7880972a251177e083cda4c7169"
        },
        {
          "id": "diligence-work-order-11-gap-resource-taxonomy-spectra-record",
          "lane": "resource-confidence",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Can a feedstock candidate move from geometry-only screening to source-backed resource diligence?",
          "nextAction": "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
          "workOrderHash": "sha256-ce13be2de8e222b90b3f72ab64e82567f72bc328ddf50d0cdf34b08ecf7cd089"
        },
        {
          "id": "diligence-work-order-12-gap-economics-launch-list-price-source",
          "lane": "economics-sensitivity",
          "priorityLane": "P1-business-grade",
          "buyerQuestion": "Do dated, normalized cost and market inputs change the scenario ranking or capital gap?",
          "nextAction": "Normalize launch-cost records into model-ready numeric inputs with calibration artifacts.",
          "workOrderHash": "sha256-98529615ecd1f236b1f6ea583e4019269b6871fe39b3b94d8d0dc2b797ce60e6"
        }
      ],
      "decisionDeltaAcceptance": [
        {
          "id": "decision-delta-diligence-work-order-01-gap-runtime-orekit-propagation-v1",
          "workOrderId": "diligence-work-order-01-gap-runtime-orekit-propagation-v1",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-696d7bc5b812c609e983bf3c079ea9563eab372629e6c8847f831b0238d1f98a"
        },
        {
          "id": "decision-delta-diligence-work-order-02-gap-runtime-gmat-transfer-v1",
          "workOrderId": "diligence-work-order-02-gap-runtime-gmat-transfer-v1",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-1d9e48de12c1383de449b7b80a4a1172bb99fa0ed70cb8a8a7f690c2a5af0ee1"
        },
        {
          "id": "decision-delta-diligence-work-order-03-gap-runtime-tudat-transfer-v1",
          "workOrderId": "diligence-work-order-03-gap-runtime-tudat-transfer-v1",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-dd7181fa4835fbf55f8cc5153d6058a2e2ab8244eab1ad37cb46cd9c5221f562"
        },
        {
          "id": "decision-delta-diligence-work-order-04-gap-materials-process-oxygen-isru",
          "workOrderId": "diligence-work-order-04-gap-materials-process-oxygen-isru",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-df7112d8c2bc06bcc2841ce59520b9ee885d5eeac25df494a604b49a79e25b83"
        },
        {
          "id": "decision-delta-diligence-work-order-05-gap-readiness-science-math-credibility",
          "workOrderId": "diligence-work-order-05-gap-readiness-science-math-credibility",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-60ac72f959528d9472829942ff72d11f66c1f5ef35f01e760a401819e06eafa9"
        },
        {
          "id": "decision-delta-diligence-work-order-06-gap-candidate-source-2026-em",
          "workOrderId": "diligence-work-order-06-gap-candidate-source-2026-em",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-e80560acfdc667dad2bc92f845f13cd8b86102818332de3fb04474fcbcda5b5a"
        },
        {
          "id": "decision-delta-diligence-work-order-07-gap-candidate-source-2026-jm2",
          "workOrderId": "diligence-work-order-07-gap-candidate-source-2026-jm2",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-773d432f747db4658c55e62bf6391a5a0810a3656b643105ca7748704fe78898"
        },
        {
          "id": "decision-delta-diligence-work-order-08-gap-candidate-source-2026-dn5",
          "workOrderId": "diligence-work-order-08-gap-candidate-source-2026-dn5",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-21f28e19a52de7ba3e8f2e9a5044ace620f6e821196ba50698501bdedd753f40"
        },
        {
          "id": "decision-delta-diligence-work-order-09-gap-materials-process-spf-db",
          "workOrderId": "diligence-work-order-09-gap-materials-process-spf-db",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-95129d4fc91c08b0c00ca68a2ff935fb273fae66f1edc1de744fff2ca6f59f21"
        },
        {
          "id": "decision-delta-diligence-work-order-10-gap-materials-process-vacuum-sheet",
          "workOrderId": "diligence-work-order-10-gap-materials-process-vacuum-sheet",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-2dd2f4bde9c960b939f68769edcb13c553ce19b66b07e1cd0d7d4926812bd121"
        },
        {
          "id": "decision-delta-diligence-work-order-11-gap-resource-taxonomy-spectra-record",
          "workOrderId": "diligence-work-order-11-gap-resource-taxonomy-spectra-record",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-a7d57999cd5183edec36a6a8900ac7bd7618bbe6be4ee0c9de0241042489605e"
        },
        {
          "id": "decision-delta-diligence-work-order-12-gap-economics-launch-list-price-source",
          "workOrderId": "diligence-work-order-12-gap-economics-launch-list-price-source",
          "acceptanceState": "blocked-pending-after-run-artifact",
          "acceptedChange": false,
          "materialChangeDetected": false,
          "blockedReason": "No after-run decision-delta artifact has been attached. The work order cannot change a customer answer yet.",
          "deltaHash": "sha256-c3233721471f01f0338f5f8ec60131bf349a311c66d08f2518ab0eecf660efc4"
        }
      ],
      "proofGates": [
        {
          "id": "source-use-rights",
          "label": "Source use rights",
          "status": "blocked",
          "evidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "requiredProof": "Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source."
        },
        {
          "id": "runtime-sidecars",
          "label": "Runtime sidecars",
          "status": "blocked",
          "evidenceHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
          "requiredProof": "Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight."
        },
        {
          "id": "model-validation",
          "label": "Model validation",
          "status": "blocked",
          "evidenceHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
          "requiredProof": "Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval."
        },
        {
          "id": "resource-candidates",
          "label": "Resource candidates",
          "status": "blocked",
          "evidenceHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
          "requiredProof": "Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim."
        },
        {
          "id": "economics",
          "label": "Economics evidence",
          "status": "blocked",
          "evidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "requiredProof": "Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads."
        },
        {
          "id": "materials-process",
          "label": "Materials/process evidence",
          "status": "blocked",
          "evidenceHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
          "requiredProof": "Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts."
        },
        {
          "id": "workspace-review",
          "label": "Workspace review",
          "status": "blocked",
          "evidenceHash": "sha256-8cca8a7ea33436d40671577ca25734edbfcbd5eb1533fdfe7149cc3d23dc1e25",
          "requiredProof": "Workspace gates, selected runs, package scope, and reviewer approvals are closed."
        }
      ],
      "blockedProofGates": [
        {
          "id": "source-use-rights",
          "label": "Source use rights",
          "status": "blocked",
          "requiredProof": "Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source.",
          "evidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
        },
        {
          "id": "runtime-sidecars",
          "label": "Runtime sidecars",
          "status": "blocked",
          "requiredProof": "Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight.",
          "evidenceHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
        },
        {
          "id": "model-validation",
          "label": "Model validation",
          "status": "blocked",
          "requiredProof": "Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval.",
          "evidenceHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2"
        },
        {
          "id": "resource-candidates",
          "label": "Resource candidates",
          "status": "blocked",
          "requiredProof": "Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim.",
          "evidenceHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608"
        },
        {
          "id": "economics",
          "label": "Economics evidence",
          "status": "blocked",
          "requiredProof": "Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads.",
          "evidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297"
        },
        {
          "id": "materials-process",
          "label": "Materials/process evidence",
          "status": "blocked",
          "requiredProof": "Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts.",
          "evidenceHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80"
        },
        {
          "id": "workspace-review",
          "label": "Workspace review",
          "status": "blocked",
          "requiredProof": "Workspace gates, selected runs, package scope, and reviewer approvals are closed.",
          "evidenceHash": "sha256-8cca8a7ea33436d40671577ca25734edbfcbd5eb1533fdfe7149cc3d23dc1e25"
        }
      ],
      "blockedClaims": [
        "No operational mission design, launch commitment, or flight-dynamics certification.",
        "No asteroid or planetary resource-composition claim without candidate-specific taxonomy, spectra, mission, or sample evidence.",
        "No commercial economics, throughput, process-quality, or manufacturability claim while economics/materials/process ledgers are blocked.",
        "No customer-facing trajectory/event-window claim until the full required runtime set and independent validation gates pass.",
        "No raw source redistribution or customer commercial use until source-use rights review passes."
      ],
      "allowedClaims": [
        "Source-backed beta context claims may be cited only with evidence hashes attached.",
        "Scenario rankings may be used as decision-support heuristics with uncertainty and blocker context visible.",
        "Evidence-gap, crossover, and diligence priorities may be used to scope paid research work."
      ],
      "evidenceAppendix": {
        "packageHash": "sha256-809457624f360385197843a54d99ec1b3a4ffb3d8f30166c91c8691ac94627e1",
        "customerReadinessContractHash": "sha256-b32de2b663893520d61d1c3429c62d9276313a853df0497df6c86f679974ad2b",
        "includedArtifactCount": 46,
        "artifactRefs": [
          {
            "id": "artifact-scenario-diligence-work-order-ledger",
            "label": "Scenario diligence work-order ledger",
            "path": "public/scenario-diligence-work-order-ledger.json",
            "hash": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
            "role": "Customer/package-linked diligence work orders, acceptance gates, affected scenarios, replay commands, and decision-delta requirements."
          },
          {
            "id": "artifact-scenario-decision-delta-ledger",
            "label": "Scenario decision delta ledger",
            "path": "public/scenario-decision-delta-ledger.json",
            "hash": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
            "role": "Fail-closed before/after acceptance records proving no diligence work order can change a customer answer without a hashed after-run artifact."
          },
          {
            "id": "artifact-customer-decision-dossier-ledger",
            "label": "Customer decision dossier ledger",
            "path": "public/customer-decision-dossier-ledger.json",
            "hash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
            "role": "Scenario-by-scenario customer-use state, buyer boundary, evidence summary, blockers, proof-to-change-answer, and next proof actions."
          },
          {
            "id": "artifact-model-validation-protocols",
            "label": "Model validation protocol ledger",
            "path": "public/model-validation-protocols.json",
            "hash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
            "role": "Domain-by-domain validation protocols, acceptance criteria, source/runtime gates, blocker states, and commercial-use boundaries."
          },
          {
            "id": "artifact-asteroid-candidate-evidence-ledger",
            "label": "Asteroid candidate evidence ledger",
            "path": "public/asteroid-candidate-evidence-ledger.json",
            "hash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
            "role": "Candidate-level SBDB/CAD/MPC/taxonomy/spectra evidence requirements, blockers, and resource-promotion gates."
          },
          {
            "id": "artifact-candidate-source-promotion-ledger",
            "label": "Candidate source promotion ledger",
            "path": "public/candidate-source-promotion-ledger.json",
            "hash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
            "role": "Candidate work-order source custody, resource-promotion, customer-use gates, report intake state, and explicit work-order gaps."
          },
          {
            "id": "artifact-candidate-source-closure-packets",
            "label": "Candidate source closure packets",
            "path": "public/candidate-source-closure-packets.json",
            "hash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
            "role": "Executable candidate-by-candidate closure packets with missing MPC, review, composition, and customer-use acceptance gates."
          },
          {
            "id": "artifact-capability-maturity-ledger",
            "label": "Capability maturity ledger",
            "path": "public/capability-maturity-ledger.json",
            "hash": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
            "role": "Business capability maturity, source coverage, model coverage, sidecar blockers, and commercialization gates."
          },
          {
            "id": "artifact-claim-evidence-ledger",
            "label": "Claim evidence ledger",
            "path": "public/claim-evidence-ledger.json",
            "hash": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
            "role": "Claim-level source coverage, confidence, promotion gates, allowed use, and blockers."
          },
          {
            "id": "artifact-feasibility-report",
            "label": "Canonical feasibility report",
            "path": "public/feasibility-report.json",
            "hash": "fnv1a32-5b0df6f9",
            "role": "Executive scenario comparison and governance summary."
          },
          {
            "id": "artifact-model-run-ledger",
            "label": "Versioned model-run ledger",
            "path": "public/model-run-ledger.json",
            "hash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
            "role": "Reproducible run inputs, uncertainty settings, rankings, and run hashes."
          },
          {
            "id": "artifact-model-run-comparison-ledger",
            "label": "Model-run comparison ledger",
            "path": "public/model-run-comparison-ledger.json",
            "hash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
            "role": "Run-to-run selected-scenario, rank-one, utility, uncertainty, business-readiness, and replay-boundary deltas."
          },
          {
            "id": "artifact-assumption-impact-ledger",
            "label": "Assumption impact ledger",
            "path": "public/assumption-impact-ledger.json",
            "hash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
            "role": "Assumption-to-scenario sensitivity, source coverage, stress behavior, and promotion gates."
          },
          {
            "id": "artifact-scenario-comparison-board",
            "label": "Scenario comparison board",
            "path": "public/scenario-comparison-board.json",
            "hash": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
            "role": "Business-grade scenario comparison board with decision score, uncertainty budget, economics, traceability, blockers, and CSV/Markdown export hashes."
          },
          {
            "id": "artifact-scenario-notebook-pack",
            "label": "Scenario notebook pack",
            "path": "public/scenario-notebook-pack.json",
            "hash": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
            "role": "Scenario-by-scenario reviewer notebooks with source coverage, open questions, blockers, work orders, and Markdown export hashes."
          },
          {
            "id": "artifact-runtime-validation-campaign-ledger",
            "label": "Runtime validation campaign ledger",
            "path": "public/runtime-validation-campaign-ledger.json",
            "hash": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
            "role": "Campaign-by-campaign runtime closure plan for SPICE, Orekit, GMAT, Tudat, and OpenMDAO/Dymos evidence promotion."
          },
          {
            "id": "artifact-runtime-closure-packet",
            "label": "Runtime closure packet",
            "path": "public/runtime-closure-packet.json",
            "hash": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
            "role": "Operator-grade runtime closure packet with setup custody, commands, intake reports, acceptance checks, and fail-closed release impact."
          },
          {
            "id": "artifact-trajectory-validation-matrix",
            "label": "Trajectory validation matrix",
            "path": "public/trajectory-validation-matrix.json",
            "hash": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
            "role": "Decision-facing SPICE/Orekit/GMAT/Tudat validation matrix with current evidence state, independent-comparison requirements, residual frontier blockers, and scenario decision links."
          },
          {
            "id": "artifact-trajectory-residual-acceptance-ledger",
            "label": "Trajectory residual acceptance ledger",
            "path": "public/trajectory-residual-acceptance-ledger.json",
            "hash": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
            "role": "Fail-closed cross-tool residual acceptance lanes for Orekit/GMAT/Tudat/SPICE comparisons before trajectory evidence can affect scenario rankings."
          },
          {
            "id": "artifact-source-use-clearance-dossier",
            "label": "Source-use clearance dossier",
            "path": "public/source-use-clearance-dossier.json",
            "hash": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
            "role": "Customer/commercial source-use clearance workflow by source class, required approvals, redistribution boundaries, and fail-closed report-use decisions."
          },
          {
            "id": "artifact-scenario-decision-audit-ledger",
            "label": "Scenario decision audit ledger",
            "path": "public/scenario-decision-audit-ledger.json",
            "hash": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
            "role": "Scenario-by-scenario explanation of ranking drivers, flip conditions, assumption sensitivities, validation protocol refs, and proof burdens."
          },
          {
            "id": "artifact-scenario-crossover-frontier",
            "label": "Scenario crossover frontier",
            "path": "public/scenario-crossover-frontier.json",
            "hash": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
            "role": "Pairwise scenario utility gaps and explicit threshold paths showing what assumptions would need to change for a challenger scenario to win."
          },
          {
            "id": "artifact-scenario-uncertainty-budget-ledger",
            "label": "Scenario uncertainty budget ledger",
            "path": "public/scenario-uncertainty-budget-ledger.json",
            "hash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
            "role": "Scenario-by-scenario decomposition of modeled uncertainty, assumption blockers, runtime gaps, source-use risk, economics evidence, and resource ambiguity."
          },
          {
            "id": "artifact-scenario-decision-ledger",
            "label": "Scenario decision ledger",
            "path": "public/scenario-decision-ledger.json",
            "hash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
            "role": "Weighted driver decomposition, uncertainty, economics, blockers, and decision lane for every scenario."
          },
          {
            "id": "artifact-scenario-traceability-matrix",
            "label": "Scenario traceability matrix",
            "path": "public/scenario-traceability-matrix.json",
            "hash": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
            "role": "Scenario-by-scenario trace from rankings to assumptions, claims, sources, model runs, runtime sidecars, and blockers."
          },
          {
            "id": "artifact-evidence-gap-priority-ledger",
            "label": "Evidence gap priority ledger",
            "path": "public/evidence-gap-priority-ledger.json",
            "hash": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
            "role": "Ranked closure backlog for source, runtime, economics, resource, traceability, and release evidence gaps."
          },
          {
            "id": "artifact-promotion-closure-ledger",
            "label": "Promotion closure ledger",
            "path": "public/promotion-closure-ledger.json",
            "hash": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
            "role": "Executable closure plans for blocked science, resource, economics, materials, and model-validation promotion gates."
          },
          {
            "id": "artifact-economics-frontier",
            "label": "Economics frontier report",
            "path": "public/economics-frontier.json",
            "hash": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
            "role": "Seeded economics Monte Carlo, rank stability, funding coverage, and promotion blockers."
          },
          {
            "id": "artifact-economics-evidence-ledger",
            "label": "Economics evidence ledger",
            "path": "public/economics-evidence-ledger.json",
            "hash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
            "role": "Dated economics source surfaces, normalization requirements, model input references, and promotion gates."
          },
          {
            "id": "artifact-materials-process-evidence-ledger",
            "label": "Materials/process evidence ledger",
            "path": "public/materials-process-evidence-ledger.json",
            "hash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
            "role": "Process-by-process material property requirements, source references, scenario fit links, runtime artifact gaps, and promotion gates."
          },
          {
            "id": "artifact-space-environment-evidence-ledger",
            "label": "Space environment evidence ledger",
            "path": "public/space-environment-evidence-ledger.json",
            "hash": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
            "role": "SPDF/CDAWeb, CCMC, SWPC, DTN, and CCSDS source requirements, scenario stress links, runtime artifact gaps, and promotion gates."
          },
          {
            "id": "artifact-sidecar-readiness-ledger",
            "label": "Runtime sidecar readiness ledger",
            "path": "public/sidecar-readiness-ledger.json",
            "hash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
            "role": "Contract-by-contract runtime readiness, promoted artifacts, blocked prerequisites, preflight evidence, command templates, and next actions."
          },
          {
            "id": "artifact-workspace-ledger",
            "label": "Research workspace ledger",
            "path": "public/workspace-ledger.json",
            "hash": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
            "role": "Project/workspace binding for runs, claims, assumptions, notebooks, and review gates."
          },
          {
            "id": "artifact-model-artifacts",
            "label": "Model artifact bundle",
            "path": "public/model-artifacts.json",
            "hash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
            "role": "Source-backed model artifact records and promotion blockers."
          },
          {
            "id": "artifact-source-refresh",
            "label": "Source refresh evidence report",
            "path": "public/source-refresh-report.json",
            "hash": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
            "role": "Snapshot-first source refresh plan and review candidate checks."
          },
          {
            "id": "artifact-source-ingestion-ledger",
            "label": "Source ingestion work-order ledger",
            "path": "public/source-ingestion-ledger.json",
            "hash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
            "role": "Source-by-source ingestion contracts, required payload hashes, normalization gates, and promotion blockers."
          },
          {
            "id": "artifact-source-use-rights-ledger",
            "label": "Source use-rights ledger",
            "path": "public/source-use-rights-ledger.json",
            "hash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
            "role": "Source-by-source terms, citation, redistribution, provider-endorsement, and customer-use review gates."
          },
          {
            "id": "artifact-source-use-review-packets",
            "label": "Source use review packets",
            "path": "public/source-use-review-packets.json",
            "hash": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
            "role": "Per-source review packets for terms/license capture, citation approval, redistribution decisions, provider-endorsement boundaries, and customer-use approval."
          },
          {
            "id": "artifact-source-query-custody-ledger",
            "label": "Source query custody ledger",
            "path": "public/source-query-custody-ledger.json",
            "hash": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
            "role": "Provider query contracts, parser boundaries, unit maps, uncertainty maps, legal notes, and non-promotion rules for live source refresh candidates."
          },
          {
            "id": "artifact-sidecar-validation",
            "label": "Science sidecar validation gate",
            "path": "public/sidecar-validation-report.json",
            "hash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
            "role": "Fail-closed intake gate for SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts."
          },
          {
            "id": "artifact-sidecar-work-orders",
            "label": "Science sidecar execution packet",
            "path": "public/sidecar-work-orders.json",
            "hash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
            "role": "Executable work orders for external SPICE/Orekit/GMAT/Tudat/OpenMDAO workers."
          },
          {
            "id": "artifact-sidecar-run-specs",
            "label": "Science sidecar run specifications",
            "path": "public/sidecar-run-specs.json",
            "hash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
            "role": "Hash-backed execution specs, required inputs, acceptance gates, and non-evidence boundaries for external science workers."
          },
          {
            "id": "artifact-sidecar-artifact-templates",
            "label": "Science sidecar artifact templates",
            "path": "public/sidecar-artifact-templates.json",
            "hash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
            "role": "Fail-closed JSON templates showing the exact output shape external science workers must fill before sidecar intake."
          },
          {
            "id": "artifact-sidecar-scaffold-rejection-ledger",
            "label": "Science sidecar scaffold rejection ledger",
            "path": "public/sidecar-scaffold-rejection-ledger.json",
            "hash": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
            "role": "Hash-backed proof that Orekit, GMAT, and Tudat beta scaffolds are contract-traceable and intentionally blocked from promotion."
          },
          {
            "id": "workspace-workspace-science-validation-backlog",
            "label": "Science Validation Backlog",
            "path": "public/workspace-ledger.json",
            "hash": "sha256-8cca8a7ea33436d40671577ca25734edbfcbd5eb1533fdfe7149cc3d23dc1e25",
            "role": "Workspace-specific project, decision gate, review gates, and evidence hashes."
          },
          {
            "id": "run-run-hybrid-base-2026-06-19",
            "label": "Hybrid base feasibility run",
            "path": "public/model-run-ledger.json",
            "hash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
            "role": "Model run selected scenario: hybrid."
          }
        ],
        "evidenceHashes": {
          "feasibilityReport": "fnv1a32-5b0df6f9",
          "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "candidateSourceClosurePackets": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
          "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
          "capabilityMaturityLedger": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
          "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
          "workspaceLedger": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
          "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
          "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
          "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
          "scenarioDecisionDeltaLedger": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
          "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
          "scenarioNotebookPack": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
          "runtimeValidationCampaignLedger": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
          "runtimeClosurePacket": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
          "trajectoryValidationMatrix": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
          "trajectoryResidualAcceptanceLedger": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
          "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
          "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
          "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
          "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
          "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
          "promotionClosureLedger": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
          "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
          "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
          "spaceEnvironmentEvidenceLedger": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
          "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
          "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
          "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
          "sourceIngestionLedger": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
          "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "sourceUseReviewPacket": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
          "sourceUseClearanceDossier": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
          "sourceQueryCustodyLedger": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
          "customerReadinessContract": "sha256-b32de2b663893520d61d1c3429c62d9276313a853df0497df6c86f679974ad2b",
          "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
          "sidecarScaffoldRejectionLedger": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
          "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
          "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
          "sidecarArtifactTemplatePacket": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
          "includedArtifacts": "sha256-e9b0f4b6b6075bbefb3eef2df9bbf5afc375e53e348ec7288776019edf984651"
        }
      },
      "exportContract": {
        "filename": "customer-report-package-science-validation-backlog-v1.json",
        "requiredAttachments": [
          "packageHash",
          "customerReadinessContractHash",
          "reportPacketHash",
          "included artifact hashes",
          "blocked proof gates",
          "source-use boundary",
          "decision-delta acceptance state"
        ],
        "approvalRequired": [
          "owner approval",
          "source-use review approval",
          "runtime sidecar promotion approval",
          "workspace review approval",
          "customer wording approval"
        ],
        "blockedExportBoundary": "This packet can be exported for internal review and paid-beta scoping only. Customer/commercial delivery remains blocked until all proof gates pass."
      },
      "blockers": [
        "Claim promotion safe: 1 workspace claims remain unverified or blocked.",
        "Customer readiness proof gate is blocked: economics.",
        "Customer readiness proof gate is blocked: materials-process.",
        "Customer readiness proof gate is blocked: model-validation.",
        "Customer readiness proof gate is blocked: resource-candidates.",
        "Customer readiness proof gate is blocked: runtime-sidecars.",
        "Customer readiness proof gate is blocked: source-use-rights.",
        "Customer readiness proof gate is blocked: workspace-review.",
        "Decision-delta acceptance records are blocked until after-run artifacts exist.",
        "Economics evidence: Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads.",
        "Materials/process evidence: Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts.",
        "Materials/process records still lack promoted material payloads and runtime physics artifacts.",
        "Model validation protocols still have blocked commercial-use gates.",
        "Model validation: Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval.",
        "No runtime sidecar artifact has promoted; mission-design claims remain blocked.",
        "Resource candidates: Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim.",
        "Runtime sidecar validation: No SPICE/Orekit/GMAT/Tudat/OpenMDAO runtime sidecar artifacts have promoted.",
        "Runtime sidecars: Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight.",
        "Source use rights: Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source.",
        "Source-use rights review blocks customer/commercial report delivery.",
        "Workspace review: Workspace gates, selected runs, package scope, and reviewer approvals are closed."
      ],
      "nextActions": [
        "Attach approved after-run decision-delta artifacts before changing any customer-facing scenario answer.",
        "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
        "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
        "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
        "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
        "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
        "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
        "Normalize launch-cost records into model-ready numeric inputs with calibration artifacts.",
        "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
        "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing."
      ],
      "evidenceHashes": {
        "feasibilityReport": "fnv1a32-5b0df6f9",
        "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioDecisionDeltaLedger": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "packageHash": "sha256-809457624f360385197843a54d99ec1b3a4ffb3d8f30166c91c8691ac94627e1",
        "customerReadinessContract": "sha256-b32de2b663893520d61d1c3429c62d9276313a853df0497df6c86f679974ad2b"
      },
      "reportPacketHash": "sha256-25a461b0426c280632742c79bacaeca78dcb14764cc2f3cb0249ab18c55a146a"
    }
  ],
  "reportExportManifest": {
    "mode": "deterministic-customer-report-export-manifest",
    "deliveryBoundary": "Markdown report exports are generated for internal review and paid-beta scoping only. They are not cleared for customer/commercial delivery until source-use, runtime, economics, materials, resource, workspace, UI, reviewer, and alerting gates pass.",
    "entries": [
      {
        "packetId": "customer-report-packet-package-investor-feasibility-brief-v1",
        "packageId": "package-investor-feasibility-brief-v1",
        "title": "Investor Feasibility Brief Package Customer Report Packet",
        "format": "markdown",
        "path": "public/customer-report-packets/customer-report-packet-package-investor-feasibility-brief-v1.md",
        "reportState": "beta-report-blocked",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "blockedExportBoundary": "This packet can be exported for internal review and paid-beta scoping only. Customer/commercial delivery remains blocked until all proof gates pass.",
        "sourceReportPacketHash": "sha256-4985a157ce5705893d4871f6dd454f3400371925267a0684f882ab65a59ab8a7",
        "contentHash": "sha256-4c214b57c24017b45b12c15b9fd0a657eec9370e91bcee121fdf764239883d61",
        "requiredAttachments": [
          "packageHash",
          "customerReadinessContractHash",
          "reportPacketHash",
          "included artifact hashes",
          "blocked proof gates",
          "source-use boundary",
          "decision-delta acceptance state"
        ],
        "approvalRequired": [
          "owner approval",
          "source-use review approval",
          "runtime sidecar promotion approval",
          "workspace review approval",
          "customer wording approval"
        ],
        "exportHash": "sha256-5cd4bf5f147ed825f4cfccd2d416d3cc95a99ce55e98bc6d318eb0b0504a95d9"
      },
      {
        "packetId": "customer-report-packet-package-asteroid-feedstock-screen-v1",
        "packageId": "package-asteroid-feedstock-screen-v1",
        "title": "Asteroid Feedstock Screen Package Customer Report Packet",
        "format": "markdown",
        "path": "public/customer-report-packets/customer-report-packet-package-asteroid-feedstock-screen-v1.md",
        "reportState": "beta-report-blocked",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "blockedExportBoundary": "This packet can be exported for internal review and paid-beta scoping only. Customer/commercial delivery remains blocked until all proof gates pass.",
        "sourceReportPacketHash": "sha256-7da7883c9760a2758063e3c19bb1f01a06ee79c8cf36404b75acca8436fe35d1",
        "contentHash": "sha256-338a155c1df6924ec35e0f51fbf21b3adfd040e71317d4db183dbe34d93c3c28",
        "requiredAttachments": [
          "packageHash",
          "customerReadinessContractHash",
          "reportPacketHash",
          "included artifact hashes",
          "blocked proof gates",
          "source-use boundary",
          "decision-delta acceptance state"
        ],
        "approvalRequired": [
          "owner approval",
          "source-use review approval",
          "runtime sidecar promotion approval",
          "workspace review approval",
          "customer wording approval"
        ],
        "exportHash": "sha256-d8a7a4fda05b250ce9bb51041079a3bac5010389c8a3cc0d7f176e454745d603"
      },
      {
        "packetId": "customer-report-packet-package-science-validation-backlog-v1",
        "packageId": "package-science-validation-backlog-v1",
        "title": "Science Validation Backlog Package Customer Report Packet",
        "format": "markdown",
        "path": "public/customer-report-packets/customer-report-packet-package-science-validation-backlog-v1.md",
        "reportState": "beta-report-blocked",
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "blockedExportBoundary": "This packet can be exported for internal review and paid-beta scoping only. Customer/commercial delivery remains blocked until all proof gates pass.",
        "sourceReportPacketHash": "sha256-25a461b0426c280632742c79bacaeca78dcb14764cc2f3cb0249ab18c55a146a",
        "contentHash": "sha256-c6ac633ac554caa35399a5c16dfc4c12e67bd1fa2b57b8a51a4be55c6743c21d",
        "requiredAttachments": [
          "packageHash",
          "customerReadinessContractHash",
          "reportPacketHash",
          "included artifact hashes",
          "blocked proof gates",
          "source-use boundary",
          "decision-delta acceptance state"
        ],
        "approvalRequired": [
          "owner approval",
          "source-use review approval",
          "runtime sidecar promotion approval",
          "workspace review approval",
          "customer wording approval"
        ],
        "exportHash": "sha256-d8d2b078407c1af655a505ba7db5331e46282924a04377aee41cddad6234b441"
      }
    ]
  },
  "ledgerHash": "sha256-dce55147724b8c11e4fd3520a1aa62b076490ea81e6670251dc5111016a8952c"
}
;
